// English locale. Mirrors ru.ts key-for-key. Russian plural groups
// (_one/_few/_many) collapse to English's two forms (_one/_other).
export const en = {
  topicCards: {
    title: 'Words picked by topic',
    topicLabel: 'Topic', topicPlaceholder: 'For example, working as a structural engineer',
    descriptionLabel: 'Description', optional: 'optional',
    descriptionPlaceholder: 'What exactly: drawings, load calculations, steel structures…',
    countLabel: 'Number of words',
    composePlaceholder: 'Topic — for example, “restaurant kitchen”',
    composePlaceholderShort: 'Topic, e.g. “kitchen”',
    descriptionAdd: '+ description', descriptionHide: '− description',
    genShort_one: '{{count}} credit', genShort_other: '{{count}} credits',
    kindPhrase: 'phrase', kindPhrasal: 'phrasal verb', tagUnavailable: 'not in dictionary', peekClose: 'Close',
    generations_one: '{{count}} credit', generations_other: '{{count}} credits',
    meanings_one: '{{count}} meaning', meanings_other: '{{count}} meanings',
    generate: 'Pick words', newBatch: 'New collection', newBatchCost: '1 credit per 10 words', starting: 'Starting…', topicRequired: 'Enter a topic.',
    quotaLow_one: 'A collection needs {{count}} credit — not enough left today.', quotaLow_other: 'A collection needs {{count}} credits — not enough left today.',
    cardQuota: 'No credits left today.',
    plans: 'Plans', alreadyRunning: 'A collection is being generated — wait for it before starting another.',
    generationError: 'Could not start the collection. Check your connection and try again; retrying will not charge twice.',
    history: 'Collections', historyEmpty: 'Your collections will be saved here.',
    historyError: 'Could not load collections.', moreHistory: 'More', loading: 'Loading…', retry: 'Retry',
    results: 'Collection', emptyTitle: 'What would you like to study?',
    hint1Title: 'Enter a topic', hint1Text: '1 credit per 10 words',
    hint2Title: 'Tick translations', hint2Text: 'nothing is added on its own',
    hint3Title: 'Create cards', hint3Text: '1 credit per 10 translations',
    hintExample: 'Example: picking 10 words — 1 credit, 15 translations selected — 2 credits.', hintExampleTotal: 'Total 3 credits',
    hintClose: 'Hide for good',
    emptyBody: 'AI picks words for the topic and checks them against the dictionary. Nothing goes into the module until you tick translations yourself.',
    notAddedYet: 'These words are not in the module yet: tick the translations you want to learn and press “Create” below.',
    pickAbove: 'Tick translations above',
    createCards_one: 'Create {{count}} card · {{cost}}', createCards_other: 'Create {{count}} cards · {{cost}}',
    detailError: 'Could not open this collection', detailErrorHint: 'It may no longer be available. Choose another one or retry.',
    moreOnTopic: 'More words on this topic', generatingTitle: 'Finding words',
    generatingBody: 'Usually 15–40 seconds. You can leave the page — the collection will be saved.',
    failedTitle: 'Could not create this collection',
    failedBody: 'Try refining the topic or description.',
    failedRefund: 'The credits for this attempt are back on your balance.',
    tryAgain: 'Edit topic', wordCount_one: '{{count}} word', wordCount_other: '{{count}} words',
    chooseModule: 'Choose a module in the title — cards will be added there.', chooseModuleShort: 'Choose a module',
    moduleError: 'Could not load modules.',
    partial: 'Found {{actual}} of {{requested}}: the rest could not be verified or already appeared in your collections.',
    checking: 'Checking words…', checkingCost: 'checking…',
    selectAll: 'Select all', deselectAll: 'Deselect all', nothingSelected: 'Nothing selected', free: 'free',
    packHint: 'Cards are created only from the ticked translations: 1 credit per 10, even across different words. Ready cards are free.',
    createIn: 'Create in “{{module}}”',
    bulkQuota: 'Credits needed: {{required}}, available: {{available}}. Deselect some or wait for new credits.',
    bulkWorking: 'Creating…', bulkChecking: 'Checking selection and cost…',
    bulkProgress: 'Sent {{done}} of {{total}}', bulkStay: 'keep this page open',
    bulkSummary: 'Added: {{added}}. Already in the module or generating: {{already}}.',
    pairLearned: 'in module', pairGenerating: 'generating', pairFree: 'free', pairUnavailable: 'This meaning is currently not in the dictionary.',
    pickLimit: 'You can create up to 10 meanings of one word at a time. Deselect the extra meanings.',
    availabilityError: 'Could not check meanings and their cost.', quotaError: 'Could not check your available credits.',
    uncertainResult: 'Could not confirm the result. Retrying first checks whether the card was added.',
    added: 'added',
    toCards: 'Open “{{module}}”', status: { generating: 'Generating', ready: 'Ready', failed: 'Failed' },
  },
  socialReward: {
    // The row in the sidebar above the credits.
    sidebar: {
      locked: 'Gift for following',
      ready: 'Refill saved',
    },
    card: {
      lockedTitle: 'A free credit refill',
      lockedHint: 'For following us on Telegram or VK',
      readyTitle: 'Refill saved',
      readyHint: 'Use it on any day',
      usedTitle: 'Refill used',
      usedHint: 'Thanks for joining us!',
      unavailable: 'Status temporarily unavailable',
      open: 'Get it',
      use: 'Use',
      hide: 'Hide',
    },
    kicker: 'A gift for following us',
    title: 'A free credit refill',
    loading: 'Checking your gift…',
    loadError: 'Could not load your gift status.',
    retry: 'Try again',
    dialogIntro: 'Follow us on Telegram or VK and we will give you one more day’s worth of credits. One subscription is enough.',
    or: 'or',
    more: 'Stay with us on other networks too',
    noUsageShort: 'No credits used today — the refill will wait',
    redeemedHint: 'You can create AI cards again',
    subscribe: 'Follow',
    verified: 'Subscription confirmed',
    notMember: 'Subscription not found',
    check: 'Check subscription',
    checkAgain: 'Check again',
    checking: 'Checking…',
    connecting: 'Connecting…',
    telegramStatus: 'Confirmed automatically once you join',
    telegramWaiting: 'Waiting for you to join…',
    linksError: 'Personal link is not ready',
    telegramBot: 'Already subscribed? Confirm in the bot',
    openInBrowser: 'Open in browser',
    vkStatus: 'Confirmed in the VK chat',
    vkWaiting: 'Tap “Start” in the VK chat',
    vkLinked: 'Now check your subscription',
    dzenStatus: 'Articles about English · optional',
    dzenOpen: 'Open',
    unavailable: 'Verification is temporarily unavailable. Please try again later.',
    readyTitle: 'Your free refill is saved',
    usedTitle: 'Gift already used',
    confirmTitle: 'Refill your credits today?',
    confirmDescription: 'Your credits will be topped back up to your plan’s full daily amount.',
    confirmOnce: 'This gift can only be used once.',
    usage: 'Credits used today: {{used}} of {{limit}}',
    confirmUse: 'Yes, refill',
    cancel: 'Back',
    redeeming: 'Refilling your credits…',
    redeemedTitle: 'Credits refilled',
    noUsage: 'You have not used any credits today. Your refill is saved for later.',
    quotaError: 'Could not check your credits. Please try again.',
    linkError: 'Could not confirm your account. Please try again.',
    accountInUse: 'This social account is already linked to another Lomora account.',
    emailRequired: 'First verify your Lomora email address. You can request a verification email on the home page.',
    rateLimited: 'Too many attempts. Wait a few minutes and try again.',
    verifyError: 'Could not check your subscription. Please try again.',
    redeemError: 'Could not refill your credits. We will check your gift status — retrying cannot use it twice.',
    notReady: 'First follow us on Telegram or VK.',
    unavailableCard: 'This gift is temporarily unavailable. Please try again later.',
  },
  training: {
    kicker: 'Practice',
    heroTitle: 'Pick a module and exercises',
    heroSub: 'Go through the cards, then match the pairs in the finale.',
    start: 'Start practice',
    startShort: 'Practice',
    newSession: 'Choose another practice',
    greetingSub: 'Practise words from your modules at your own pace.',
    friend: 'friend',
    home: 'Home',
    stepModule: 'Step 1 of 2 · module',
    chooseModule: 'What shall we practise?',
    chooseSub: 'Choose one module. Next, select your exercises and cards.',
    cardCount_one: '{{count}} card',
    cardCount_other: '{{count}} cards',
    loadError: 'Could not load your modules. Please try again.',
    resumeError: 'Could not check your unfinished session. You can resume it from its module.',
    retry: 'Try again',
    words_one: '{{count}} word',
    words_other: '{{count}} words',
    rowEmpty: 'No ready words yet',
    rowUntrained_one: '{{count}} word not studied yet',
    rowUntrained_other: '{{count}} words not studied yet',
    rowToday: 'Today {{count}}',
    rowMore: '{{count}} more',
    rowTomorrow: 'tomorrow {{count}}',
    rowDone: 'Done today: {{count}}',
    rowRepeat: 'Review {{count}}',
    rowNew_one: '{{count}} not studied yet',
    rowNew_other: '{{count}} not studied yet',
    rowNothing: 'Nothing to review yet',
  },
  today: {
    streak_one: '{{count}} day in a row',
    streak_other: '{{count}} days in a row',
    week: 'Practice this week: {{count}} days',
    weekdays: 'Mo,Tu,We,Th,Fr,Sa,Su',
    streakStart: 'Your streak starts today',
    dayCounted: 'Today counts',
    kicker: 'Today’s practice',
    repeatBig_one: 'word to review',
    repeatBig_other: 'words to review',
    dayPendingShort: 'Counts after a practice',
    rewardTokens_one: '+{{count}} credit',
    rewardTokens_other: '+{{count}} credits',
    rewardToday: 'for practising today',
    rewardTomorrow: 'tomorrow',
    rewardIn_one: 'in {{count}} day',
    rewardIn_other: 'in {{count}} days',
    rewardHint: 'Non-expiring credits for your practice streak.',
    repeatTitle_one: 'Review {{count}} word today',
    repeatTitle_other: 'Review {{count}} words today',
    repeatMoreTitle_one: '{{count}} more word to review today',
    repeatMoreTitle_other: '{{count}} more words to review today',
    mistakes_one: '{{count}} with a mistake',
    mistakes_other: '{{count}} with mistakes',
    stale_one: '{{count}} not seen for a while',
    stale_other: '{{count}} not seen for a while',
    and: ' and ',
    inModules_one: 'in {{count}} module',
    inModules_other: 'in {{count}} modules',
    tomorrowTitle_one: 'Review {{count}} word tomorrow',
    tomorrowTitle_other: 'Review {{count}} words tomorrow',
    doneToday: 'Done today: {{count}}.',
    tomorrowFirst: 'Tomorrow, first up: {{words}} — they had mistakes.',
    firstShort: 'first up: {{words}}',
    doneCountTitle_one: '{{count}} word done today',
    doneCountTitle_other: '{{count}} words done today',
    newAvailable_one: '{{count}} more word not studied yet.',
    newAvailable_other: '{{count}} more words not studied yet.',
    addWords: 'Add new words in the bar below.',
    freshTitle: 'Nothing to review today',
    freshSub: 'Words from past practice will come back in a couple of days.',
    startNewTitle: 'Start with new words',
    startNewSub_one: '{{count}} word is waiting for its first practice',
    startNewSub_other: '{{count}} words are waiting for their first practice',
    emptyTitle: 'No words to practise yet',
    emptySub: 'Add a word in the bar below — it will show up here.',
  },
  brand: {
    name: 'Lomora',
  },
  createCard: {
    fab: 'Card',
    fabTitle: 'Create card',
  },
  // The card bar at the bottom of the dashboard (widgets/HomeComposer). Shared parts (choice summary,
  // price, create errors) live in cardsWorkspace.*: /cards/new shows them too.
  homeComposer: {
    label: 'New card',
    fieldAria: 'New word for a card',
    placeholder: 'Look up a word and make a card — e.g. travel',
    placeholderShort: 'Look up in the dictionary…',
    manualPlaceholder: 'A word or phrase — e.g. travel',
    manualPlaceholderShort: 'A word or phrase…',
    cyrillic: 'Type an English word — for example, travel',
    slow: 'slow connection — still looking…',
    collapse: 'Collapse',
    sheetAria: 'Meanings of {{word}}',
    createShortPaid: 'Create · 1 credit',
    createShort: 'Create',
    addCard: 'Add card',
    addShort: 'Add',
    inModule: 'to “{{title}}”',
    manualLine: 'To “{{module}}” — no AI: just the word and its translation. No hint, meaning note or sentence exercises.',
    manualNote: 'Manual card to “{{module}}”\u00a0— word and translation only',
    // «Add» linked the student’s own card of this word from another module; the typed translation wasn’t applied
    // (spec § 22.6, § 18.3; acceptance A2-03). Without the module from the server — without its name.
    manualReused: 'This word is already in “{{module}}”\u00a0— we added the same card; your translation wasn’t applied.',
    manualReusedElsewhere: 'This word is already in another module\u00a0— we added the same card; your translation wasn’t applied.',
    topicPill: 'Pick 10–20 words on a topic',
    manualButton: 'Manual',
    lockedEmail: 'Opens after you confirm your email',
    lockedEmailShort: 'After you confirm your email',
    chooseAria: 'Choose translations',
    showAnswer: 'Show the dictionary answer',
    lookupError: 'Couldn’t check the word. Try again.',
    offline: 'We’ll check the word once you’re back online.',
    quotaOutPhone: 'Out of credits — ready meanings and manual cards need none',
    refill: 'Refill by following us',
    errors: {
      checking: 'Connection dropped — checking whether the cards were created…',
      checkFailed: 'Can’t check whether the cards were created — we’ll check once you’re back online.',
      notCreated: 'The cards weren’t created — try again.',
      moduleGone: 'The “{{title}}” module was deleted — pick another one.',
      modulesFailed: 'Modules didn’t load — try again.',
      nothingAdded: 'Nothing added — you’re already learning these or they’re not in the dictionary.',
      notConfirmed: 'Couldn’t confirm the cards were created — press again: you won’t be charged twice.',
    },
    module: {
      aria: 'Cards go to “{{title}}”. Change module',
      prefix: 'to',
      title: 'Where to add the cards',
      search: 'Find a module',
      recent: 'Recent',
      all: 'All modules',
      empty: 'Nothing found for “{{q}}”',
      new: 'New module',
      loading: 'Loading modules…',
    },
    // The signal above the bar (spec § 8): the press status with a link to its «Recently added» entry while
    // that entry is out of sight.
    signal: {
      generating: 'Generating',
      slow: 'Taking longer:',
      ready: 'Ready:',
      added: 'Added:',
      failed: 'Failed:',
      failedShort: 'Failed:',
      cards_one: '· {{count}} card',
      cards_other: '· {{count}} cards',
      failedOf: '· {{failed}} of {{total}}',
      more: '+{{count}}',
      show: 'View',
      aria: 'Show “{{title}}”',
      dismiss: 'Dismiss',
      live: {
        started: 'Generating {{title}}',
        ready: 'Ready: {{title}}, {{cards}}',
        failed: 'Failed: {{title}}',
      },
    },
  },
  // «Recently added» under the modules on the dashboard (widgets/GenerationsList, spec § 14, § 22, § 23.2).
  generations: {
    title: 'Recently added',
    titleVisit: 'Today',
    cards_one: '{{count}} card',
    cards_other: '{{count}} cards',
    manual: 'added manually',
    topic: 'Topic: {{topic}}',
    status: {
      generating: 'generating',
      progress: '{{done}} of {{total}} ready',
      slow: 'taking longer than usual',
      ready: 'ready',
      failedOf: 'failed: {{failed}} of {{total}}',
      failedTail: ': {{failed}} of {{total}}',
      failed: 'failed',
      removed: 'deleted',
    },
    time: {
      now: 'just now',
      min: '{{count}} min',
      hour: '{{count}} h',
      yesterday: 'yesterday',
    },
    rowAria: '{{title}}, module “{{module}}”, {{status}}, {{date}}',
    more: 'Show more',
    less: 'Show less',
    loading: 'Loading…',
    loadError: 'Couldn’t load the list.',
    moreError: 'Didn’t load.',
    retry: 'Retry',
    detail: {
      error: 'Couldn’t load the details.',
      gone: 'This entry is gone — its module was deleted.',
    },
    // The count stays with the last word: “Phrasal / verbs · 1”, not a lone “· 1” on the second line (A2-05).
    section: {
      translations: 'Translations',
      words: 'Words\u00a0·\u00a0{{count}}',
      phrases: 'Phrases\u00a0·\u00a0{{count}}',
      phrasalVerbs: 'Phrasal verbs\u00a0·\u00a0{{count}}',
      skipped: 'Not created\u00a0·\u00a0{{count}}',
    },
    // The credit line of a press — by the credit holders in the details (spec § 23.2).
    token: {
      none: 'No credit was charged.',
      refunded: 'The credit for this was refunded.',
      refundedCount_one: '{{count}} credit for this was refunded.',
      refundedCount_other: '{{count}} credits for this were refunded.',
      spent_one: 'The credit went to what’s ready.',
      spent_other: 'The credits went to what’s ready.',
      checked_one: 'The credit went to checking the word.',
      checked_other: 'The credits went to checking the words.',
    },
    manualNote: 'Added manually — no example, meaning or hint.',
    item: {
      generating: 'generating',
      slow: 'taking longer than usual',
      extending: 'adding a part of speech',
      notAdded: 'not added',
      failed: 'failed',
      failedReason: 'The AI didn’t respond in time — try again.',
      restricted: 'The AI won’t process this word: it has 18+ meanings in the dictionary. Add the card manually.',
      typo: 'looks like a typo',
      suggest: 'Did you mean {{word}}?',
      garbage: 'not recognised',
      removed: 'deleted',
    },
    skip: {
      already_added: 'already in the module',
      not_in_dictionary: 'not in the dictionary',
      not_in_topic: 'off topic',
      quota: 'not enough credits',
      in_progress: 'still generating',
      error: 'failed',
      other: 'not created',
    },
    action: {
      retryPaid: 'Retry · 1 credit',
      retryShort: 'Retry · 1',
      retrying: 'Starting…',
      noCredits: 'Out of credits',
      manual: 'Add manually',
      fix: 'Review',
      enterWord: 'Enter “{{word}}”',
      reenter: 'Enter again',
      openModule: 'Open module →',
      train: 'Practise new',
      collapse: 'Collapse',
      // Hiding a portion is not “Collapse”: that is the whole entry’s button (A2-06). fewerItems — next to “N more”.
      fewer: 'Show fewer',
      fewerItems: 'show fewer',
      moreSenses_one: 'Show {{count}} more translation',
      moreSenses_other: 'Show {{count}} more translations',
    },
    errors: {
      retryFailed: 'Couldn’t start it. Try again.',
      cardGone: 'This card is no longer in the module.',
    },
  },
  shared: {
    passwordInput: {
      show: 'Show password',
      hide: 'Hide password',
    },
  },
  network: {
    serverDown: {
      title: 'Server is not responding',
      sub: 'Looks like a connection problem or the server is temporarily down. We keep trying to reconnect.',
    },
    offline: {
      title: 'No internet connection',
      sub: 'Check your Wi-Fi or mobile network. As soon as you’re back online, we’ll resume automatically.',
    },
    reconnected: {
      title: 'Connection restored',
      sub: 'Refreshing data…',
    },
    retry: 'Retry',
    retrying: 'Connecting…',
  },
  emailVerify: {
    full: {
      resend: 'Send again',
      resendDone: '✓ Sent',
      resendCooldown: 'Resend in {{n}}\u00a0s',
      resending: 'Sending…',
      resendError: 'Failed — try again',
      preview: 'open the email (preview) →',
    },
    compact: {
      titlePrefix: 'Email',
      titleSuffix: 'not verified yet',
      body: 'Confirm your email to unlock your own words.',
      resend: 'Send again',
      resendDone: '✓ Sent',
      resendCooldown: 'Resend in {{n}}\u00a0s',
      resending: 'Sending…',
      resendError: 'Failed — try again',
    },
    // Introduction result (EmailConfirmNote) and the locked create bar on the dashboard; button labels come from full.
    nudge: {
      title: 'Confirm your email to keep creating cards',
      bodyPrefix: 'The link is in the email we sent to',
    },
  },
  auth: {
    signIn: {
      title: 'Welcome back',
      sub: 'Sign in to keep learning.',
      submit: 'Sign in',
      noAccount: 'No account?',
      switchToSignUp: 'Create one',
    },
    signUp: {
      title: 'Create account',
      sub: 'Collect your words and practise at your own pace.',
      subGame: 'Straight into the game after sign-up. A new London mission every day.',
      submit: 'Create account',
      hasAccount: 'Already have an account?',
      switchToSignIn: 'Sign in',
    },
    fields: {
      name: 'Name',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm password',
      namePlaceholder: 'Alex',
      emailPlaceholder: 'you@example.com',
      passwordPlaceholder: '••••••••',
      confirmPasswordPlaceholder: 'repeat password',
    },
    social: {
      orEmail: 'or email',
      yandex: 'Yandex',
    },
    promo: {
      kicker: 'English practice at your own pace',
      quotePart1: 'Your words',
      quotePart1Em: 'within reach',
      quotePart2: 'Your practice',
      quotePart2Em: 'your way',
      footer: 'Modules · cards · exercises',
    },
    errors: {
      invalidCredentials: 'Wrong email or password',
      requiredFields: 'Fill in all fields',
      shortPassword: 'At least 8 characters',
      invalidEmail: 'Invalid email',
      nameRequired: 'Enter your name',
      emailRequired: 'Enter your email',
      passwordRequired: 'Enter a password',
      confirmRequired: 'Confirm the password',
      passwordMismatch: 'Passwords do not match',
      emailExists: 'An account with this email already exists',
      network: 'Could not reach the server',
      invalidName: 'Name — up to 50 characters',
      invalidData: 'Check the fields and try again',
      rateLimited: 'Too many attempts — wait a minute',
      server: 'Something went wrong — try again',
      offerRequired: 'Accept the offer to continue',
    },
    version: 'v2.4 · 2026',
    versionSecure: 'v2.4 · 2026 · secure request',
    forgotLink: 'Forgot password?',
    forgot: {
      stepTags: {
        a: '01 · email',
        b: '02 · letter',
        c: '03 · password',
      },
      backToSignIn: 'back to sign in',
      title: 'Forgot password?',
      leadHead: 'It happens. Enter your email — we’ll send a link to',
      leadStrong: 'set a new password',
      leadTail: '.',
      emailLabel: 'Account email',
      submit: 'Send the link',
      info: 'If there’s no such account — we’ll still show “sent”. This protects our learners from email enumeration.',
      rememberPrefix: 'Remembered your password?',
      rememberLink: 'Sign in',
      sent: {
        title: 'The email',
        titleEm: 'is on its way',
        subPrefix: 'Open your inbox and click “Reset password”. If you don’t see it within a minute — check “Promotions” and “Spam”. Sent to',
        next: 'Go to password reset',
        back: 'Back to sign in',
        resendPrompt: 'Didn’t arrive?',
        resend: 'send again',
        resendIn: 'in {{time}}',
        resendReady: 'ready',
      },
      errors: {
        invalidEmail: 'That doesn’t look like an email — check the address.',
      },
      promo: {
        eyebrow: 'Password reset · 3 steps',
        quotePart1: 'No',
        quotePart1Em: 'extra',
        quotePart1Tail: 'questions.',
        quotePart2: 'Just a new',
        quotePart2Em: 'password',
        quotePart2Tail: '.',
        steps: [
          { num: '01', head: 'Email', desc: 'Tell us which address to send the link to.' },
          { num: '02', head: 'Letter', desc: 'The button in the email opens the password-reset page. The link lives for 15 minutes.' },
          { num: '03', head: 'New password', desc: 'Double entry, a strength check — and back to your cards.' },
        ],
        foot: 'security@lomora.ru',
      },
    },
    confirmEmail: {
      kicker: 'Email confirmation',
      pending: {
        title: 'Confirming your email…',
        sub: 'One second — checking your link.',
      },
      success: {
        title: 'Email',
        titleEm: 'confirmed',
        sub: 'Done — you can add your own words now.',
        redirectPrefix: 'Taking you to',
        targetApp: 'the home page',
        targetSignIn: 'the sign-in screen',
        redirectSuffix: '…',
        goApp: 'To home',
        goSignIn: 'Go to sign in',
      },
      // The link is stale (expired, used or wrong) but the signed-in learner’s email is confirmed (B6).
      already: {
        title: 'Your email is already confirmed',
        sub: 'All set — your own words are already unlocked.',
      },
      error: {
        title: 'The link didn’t work',
        expiredTitle: 'This link has expired',
        // The address (EmailText) follows, hence the split.
        expiredAppPrefix: 'Links work once and expire after 24 hours. We’ll send a new one to',
        expiredGuest:
          'Links work once and expire after 24 hours. If your email is already confirmed, just sign in. If not, sign in and tap “Send again” — we’ll email you a new link.',
        resend: 'Send a new email',
        sentPrefix: 'We’ve sent a new email to',
        sentSuffix: '. Open it and click the button inside.',
        missing: 'The link didn’t open in full. Open the email again and click the button inside.',
        network: 'Can’t reach the server. Check your connection and try again.',
        rateLimit: 'Too many attempts. Wait a minute and try again.',
        generic: 'Something went wrong on our side. Try again in a minute.',
        retry: 'Try again',
        signIn: 'Sign in',
        back: 'Back to sign in',
      },
    },
    oauth: {
      kicker: 'Sign in via provider',
      pending: {
        title: 'Finishing sign-in…',
        sub: 'One second — setting up your session.',
      },
      success: {
        title: 'Wel',
        titleEm: 'come',
        sub: 'Session created. We’ll open the home page so you can learn some words.',
        redirectPrefix: 'Taking you to',
        redirectStrong: 'the home page',
        redirectSuffix: '…',
        goApp: 'To home',
      },
      error: {
        title: 'Could not sign in',
        OAUTH_PROVIDER_ERROR: 'The provider returned an error and stopped the sign-in. Try again.',
        OAUTH_MISSING_PARAMS: 'The link lost its parameters. Start the sign-in again.',
        INVALID_OAUTH_STATE: 'The link is stale or was opened in a different browser. Start the sign-in again.',
        OAUTH_PROVIDER_MISMATCH: 'The provider didn’t match the one you started with. Try again.',
        OAUTH_LOGIN_FAILED: 'Couldn’t complete the sign-in. Try again in a minute.',
        OAUTH_REFRESH_FAILED: 'We didn’t get a session token. Sign in again.',
        generic: 'Something went wrong. Try again.',
        back: 'Back to sign in',
      },
    },
    reset: {
      stepTags: {
        a: '01 email',
        b: '02 letter',
        c: '03 · password',
      },
      ttlPrefix: 'link lives for',
      ttlExpired: 'expired',
      title: 'New password',
      lead: 'Pick a password you won’t lose. Minimum — 8 characters; we recommend a long phrase.',
      pw1Label: 'New password',
      pw1Hint: 'at least 8 characters',
      pw2Label: 'Repeat the new password',
      submit: 'Save new password',
      backPrefix: 'Changed your mind?',
      backLink: 'Back to sign in',
      chars: '{{n}} chars',
      strength: {
        idle: 'enter a password — we’ll show its strength',
        label: 'strength',
        levels: ['weak', 'basic', 'good', 'strong', 'rock-solid'],
      },
      rules: {
        len: 'from 8 characters',
        mix: 'mixed-case letters',
        num: 'at least one digit',
        sym: 'a special char or 12+ chars',
      },
      match: {
        empty: 'enter the password again to verify',
        ok: '✓ passwords match',
        bad: '× passwords do not match',
      },
      errors: {
        missingToken: 'The link has no token. Request a new one via “Forgot password?”.',
        expired: 'The link has expired or was already used. Request a new one.',
        generic: 'Could not update the password. Try again.',
      },
      verify: {
        checking: 'Checking the link…',
        invalid: {
          title: 'This link didn’t work',
          body: 'This password-reset link is invalid or has expired. Request a new one — it lives for 15 minutes.',
          cta: 'Request a new link',
        },
      },
      done: {
        title: 'Done, your password is',
        titleEm: 'updated',
        sub: 'All other sessions were signed out automatically. Sign in again with the new password — and keep learning.',
        redirectPrefix: 'Taking you to',
        redirectStrong: 'the sign-in screen',
        redirectSuffix: '…',
        loginNow: 'Sign in now',
      },
      promo: {
        eyebrow: 'Final step · 03 / 03',
        quotePart1: 'One password —',
        quotePart2: 'and back to',
        quotePart2Em: 'the cards',
        quotePart2Tail: '.',
        cardTitle: 'What happens after you save',
        cardItems: [
          { num: '01', head: 'All devices sign out.', body: 'Your phone and other browsers will ask you to sign in again.' },
          { num: '02', head: 'Progress is safe.', body: 'Cards, reviews, statistics — everything stays in place.' },
          { num: '03', head: 'The link expires.', body: 'It won’t work a second time — request a new one if you need it.' },
        ],
        foot: 'security@lomora.ru',
      },
    },
  },
  onboarding: {
    skip: 'Skip',
    errorRetry: 'Could not save. Try again.',
    appLoader: 'Loading profile…',
    // Introduction (2026-10-19): module screen → 5-word practice → result.
    intro: {
      title: 'Lomora — an English vocabulary trainer',
      pointDictionary: 'Translations and transcriptions come from a dictionary',
      pointTopics: 'Ready-made topics and your own words',
      pointQuick: 'Practice takes 2 minutes',
      moduleLabel: 'Your first module',
      pickLabel: 'Pick a topic',
      otherTopic: 'another topic',
      collapse: 'collapse',
      words_one: '{{count}} word',
      words_other: '{{count}} words',
      starterError: 'Could not load the topic.',
      starterRetry: 'Retry',
      start: 'Start: 5 words in 2 minutes',
      starting: 'Preparing your practice…',
      skipping: 'Saving…',
      startError: 'Practice did not start. Try again or skip.',
      networkError: 'No connection to the server. Check your internet and try again.',
      rateLimit: 'Too many attempts. Wait a minute and try again.',
      choiceTitle: 'Where shall we start?',
      missionLabel: 'Game',
      missionTitle: 'Mission of the day in London',
      missionText: 'Talk to a Londoner in English\u00a0— by voice or text. 3–5 minutes, AI reviews your answers.',
      missionStart: 'Play',
      missionStarting: 'Opening the mission…',
      lookAround: 'Look around first',
      // «Your words» — a card for the learner's own word (owner's decision 2026-11-02).
      cardLabel: 'Your words',
      cardTitle: 'A card for your own word',
      cardText: 'Type a word from a book, a show or work. Translation and transcription come from the dictionary; AI adds an example and meaning.',
      cardStart: 'Create a card',
      cardStarting: 'Opening…',
      cardModule: 'My words',
    },
    training: {
      noteMcq: 'Don’t know the word? Pick by the meaning of the sentence. We’ll show the translation after you answer.',
      noteInput: 'Translate only the highlighted word, not the whole sentence. Don’t know it? Tap “no idea” — we’ll show the translation and an example.',
    },
    result: {
      score: '{{correct}} of {{total}}',
      scorePerfect: '{{correct}} of {{total}}!',
      firstTry: 'right on the first try',
      newWords_one: '{{count}} new word in your module',
      newWords_other: '{{count}} new words in your module',
      firstTryCount: '{{count}} right on the first try',
      zeroFirstTry: 'The words will come back in your next practice — that’s how they stick.',
      streak: 'Day 1 of your streak',
      noScoreTitle: 'Your module is on the home page',
      noScoreSub: 'You can continue practice any time.',
      remindTitle: 'When should we remind you?',
      remindVia: 'By email',
      remindMsk: 'Moscow time',
      remindOff: 'no thanks',
      toDashboard: 'Go to home',
      saving: 'Saving…',
    },
    // The cards below are read only by SessionGuide (not mounted on the home page).
    steps: {
      session: {
        cards: {
          c1: {
            h: 'Pick a module',
            t: 'Press “Start practice” on the home page and pick a module. You can also start practice from the module itself.',
          },
          c2: {
            h: 'Build your session',
            t: 'Choose exercises. Keep every card in the module or select just the ones you want.',
          },
          c3: {
            h: 'Practice',
            t: 'Answer at your own pace. If you make a mistake, you’ll see the correct answer before you continue.',
          },
          c4: {
            h: 'Finale and results',
            t: 'Finish by matching words in pairs, then see your results. If you need to stop sooner, press “Finish early”.',
          },
        },
      },
    },
  },
  trainingGuide: {
    title: 'How practice works',
    sub: 'module, exercises and finale',
    close: 'Got it',
  },
  nav: {
    dashboard: 'Home',
    words: 'Words & modules',
    grammar: 'Grammar',
    game: 'Game',
    more: 'More',
    notifications: 'Notifications',
    profile: 'Settings',
    plans: 'Plans',
    community: 'Community',
    useful: 'Useful',
    stories: 'Survive London',
    newBadge: 'new',
    admin: 'Admin',
    installApp: 'Install on your phone',
    aria: {
      expand: 'Expand sidebar',
      collapse: 'Collapse sidebar',
      home: 'Lomora — home',
      tabs: 'Sections',
      moreUnread_one: 'More: {{count}} new notification',
      moreUnread_other: 'More: {{count}} new notifications',
      profileMenu: 'Profile menu',
      notificationsCount_one: 'Notifications, {{count}} new',
      notificationsCount_other: 'Notifications, {{count}} new',
    },
  },
  useful: {
    title: 'Useful',
    sub: 'Irregular and phrasal verbs, English sounds and the alphabet: tables with transcription, audio and drills. Explanations are in Russian.',
    tabs: {
      verbs: 'Irregular verbs',
      phrasal: 'Phrasal verbs',
      sounds: 'English sounds',
      alphabet: 'English alphabet',
    },
  },
  grammar: {
    intro: 'Rules step by step: read one, then practise right away. Every exercise earns stars.',
    levels: 'Level',
    pathLabel: 'Level {{level}} topics',
    continue: 'Continue',
    startHere: 'Start here',
    next: 'Go',
    youAreHere: 'you are here',
    mastered: 'mastered',
    passed: 'done',
    reviewDue: 'time to review',
    legend: {
      passed: 'done\u00a0— exercise\u00a01 finished',
      mastered_one: 'mastered\u00a0— “{{level}}” and a clean review after\u00a0{{count}} day',
      mastered_other: 'mastered\u00a0— “{{level}}” and a clean review after\u00a0{{count}} days',
    },
    recommended: 'Worth learning next',
    draft: 'Draft',
    empty: 'No topics on this level yet.',
    loadError: 'Couldn’t load grammar.',
    retry: 'Retry',
    blank: 'blank',
    starsLabel: 'Exercises done: {{done}} of {{total}}',
    lesson: {
      back: 'Grammar',
      requires: 'Revise first',
      contrasts: 'Don’t mix up with',
      seeAlso: 'More on this',
      mistakes: 'Common mistakes',
      exercises: 'Exercises',
      core: 'The main idea',
      step: 'Step {{n}}',
      stepOf: 'Step {{n}} of {{total}}',
      stepsNav: 'Lesson steps',
      goToStep: 'Step {{n}}: {{title}}',
      prev: 'Back',
      next: 'Next',
      nextTo: 'Next: {{title}}',
      toExercises: 'To the exercises',
      check: 'Check yourself',
      mistake: 'Common mistake',
      sheet: 'Cheat sheet',
      sheetHint: 'Fills in step by step',
      sheetLocked: 'Opens at step {{n}}',
      aside: 'Cheat sheet and exercises',
      compareRu: 'In Russian',
      compareEn: 'In English',
      gap: 'nothing is said here in Russian',
      notWritten: 'The lesson is still being written — only admins see it.',
      notFound: 'This topic doesn’t exist or isn’t ready yet.',
      passRule: 'A topic counts after exercise\u00a01.',
      readTitle: 'Lesson read',
      readNext: 'Now exercise\u00a01\u00a0— it marks the topic done.',
      passedTitle: 'Topic done',
      masterNext_one: 'To master it: “{{level}}” and a clean review after\u00a0{{count}} day.',
      masterNext_other: 'To master it: “{{level}}” and a clean review after\u00a0{{count}} days.',
      masteredTitle: 'Topic mastered',
    },
    exercise: {
      verify: 'Paid exercises need a confirmed email — open the link from our email.',
      title: 'Exercise {{n}}',
      hint: 'From easy to hard: the first one is free, the hard ones have the traps you learn the most from.',
      items_one: '{{count}} task',
      items_other: '{{count}} tasks',
      free: 'Free',
      start: 'Start',
      continue: 'Continue',
      again: 'Again',
      opening: 'Unlocking…',
      openFor_one: 'Unlock · {{count}} token',
      openFor_other: 'Unlock · {{count}} tokens',
      goTo: 'Go to exercise {{n}}',
      openNo_one: 'Unlock exercise {{n}} · {{count}} token',
      openNo_other: 'Unlock exercise {{n}} · {{count}} tokens',
      noTokens: 'Not enough tokens',
      openError: 'Couldn’t unlock the exercise. Try again.',
      levelLabel: 'Difficulty',
      levels: {
        easy: 'Easy',
        medium: 'Medium',
        hard: 'Hard',
        master: 'Master',
      },
    },
    openConfirm: {
      kicker: 'Open the exercise',
      text_one: 'This costs {{count}} token. The exercise opens once and stays yours — redo it as often as you like.',
      text_other: 'This costs {{count}} tokens. The exercise opens once and stays yours — redo it as often as you like.',
      balance_one: 'Balance: {{count}} token',
      balance_other: 'Balance: {{count}} tokens',
      cancel: 'Cancel',
    },
    play: {
      verifyTitle: 'AI feedback needs a confirmed email',
      verifyText: 'Open the link from our email and the AI will review your free answers. Choice tasks are checked right away.',
      verifyTextTo: 'Open the link in the email we sent to {{email}} and the AI will review your free answers. Choice tasks are checked right away.',
      exit: 'Back to the lesson',
      progress: 'Task {{n}} of {{total}}',
      analysesLeft_one: '{{count}} review left',
      analysesLeft_other: '{{count}} reviews left',
      analysesHint: 'A review — AI checks your answer and explains the mistake',
      types: {
        choice: 'Choose the right option',
        fill: 'Fill in the gap',
        fillFree: 'Write the answer in English',
        fix: 'Fix the mistake',
        translate: 'Translate into English',
        write: 'Write your own sentence',
      },
      example: 'For example:',
      showExample: 'Show an example',
      placeholder: 'Your answer in English',
      check: 'Check',
      checking: 'Checking…',
      correct: 'Correct! 🎉',
      almost: 'Almost! 👍',
      wrong: 'Not quite 🙂',
      rightAnswer: 'Right answer:',
      review: 'Review',
      reviewFree: 'free',
      reviewPaid: 'bought',
      next: 'Next',
      finish: 'Done',
      noAnalysesTitle: 'Free reviews are used up',
      noAnalysesText_one: '{{dose}} more review — and AI checks your answer and explains the mistakes.',
      noAnalysesText_other: '{{dose}} more reviews — and AI checks your answer and explains the mistakes.',
      buyDose_one: '{{dose}} more reviews · {{count}} token',
      buyDose_other: '{{dose}} more reviews · {{count}} tokens',
      skip: 'Skip',
      noTokensText: 'New tokens come tomorrow, and you can get more in Plans.',
      plans: 'Plans',
      unavailable: 'AI didn’t answer — the review wasn’t used. Try again.',
      notEnglish: 'Write your answer in English.',
      error: 'Couldn’t check it. Try again.',
      tryAgain: 'Try again',
      notFound: 'This exercise doesn’t exist.',
      lockedTitle: 'Exercise {{n}} is locked',
      lockedText_one: 'Unlock it for {{count}} token — once, and it stays yours.',
      lockedText_other: 'Unlock it for {{count}} tokens — once, and it stays yours.',
      finishTitle: 'Exercise complete!',
      finishText: 'Correct: {{solved}} of\u00a0{{total}}',
      starsLabel_one: '{{count}} star of 3',
      starsLabel_other: '{{count}} stars of 3',
      nextExercise: 'Next: exercise {{n}}',
      toLesson: 'Back to the lesson',
      again: 'Do it again',
      passedTitle: 'Topic done!',
      nextTopic: 'Next topic',
      openShort_one: 'Exercise\u00a0{{n}} · {{count}} token',
      openShort_other: 'Exercise\u00a0{{n}} · {{count}} tokens',
      fixTitle: 'Almost there!',
      fixText_one: '{{count}} item left to fix — answer it again until everything is green.',
      fixText_other: '{{count}} items left to fix — answer them again until everything is green.',
      fixStart: 'Fix mistakes',
      fixChip: 'Fixing mistakes',
      backTo: 'Back to item {{n}}',
      retry: 'Answer again',
      yourAnswer: 'Your answer:',
      itemLabel: 'Item {{n}}: {{state}}',
      before: 'Earlier: {{state}}',
      tone: {
        right: 'correct',
        wrong: 'with a mistake',
        none: 'not answered',
      },
    },
    review: {
      kicker: 'Review',
      title: 'Review what you learned',
      why: 'Learned topics fade just like words. So we keep track of what you learn and put together the topics you studied a day or a few days ago — to review them before they fade.',
      reasonDue: 'time to review',
      reasonMistakes_one: '{{count}} mistake',
      reasonMistakes_other: '{{count}} mistakes',
      meta_one: '{{count}} task · about three minutes',
      meta_other: '{{count}} tasks · about three minutes',
      reward_one: '+{{count}} token',
      reward_other: '+{{count}} tokens',
      start: 'Start',
      later: 'Later',
      finish: 'Finish',
      doneTitle: 'Review done!',
      score: '{{right}} of {{total}} right',
      doneClean: 'No mistakes — these topics come back later.',
      doneMistakes: 'Topics with mistakes come back tomorrow — that is how they stick.',
      nextDue: 'Next review — {{date}}',
      emptyTitle: 'Nothing to review today',
      emptyText: 'A review appears once you have learned topics: the first one comes a day after the lesson.',
      toGrammar: 'To grammar',
      toHome: 'Home',
      loadFailed: "Couldn't load the review. Check your connection and try again.",
      failed: "The answer didn't go through. Try again.",
      stale: 'The review has changed — a new day has started. Open it again.',
      rowKicker: 'Review grammar',
      rowAction: 'Review',
      rowDone: "Today's review is done",
    },
    title: 'Grammar',
    rewards: {
      progress_one: '{{count}} more topic to a reward: +{{tokens}}',
      progress_other: '{{count}} more topics to a reward: +{{tokens}}',
      rule_one: '+{{count}} non-expiring token for every {{step}} topics passed',
      rule_other: '+{{count}} non-expiring tokens for every {{step}} topics passed',
      hardTitle_one: 'Tricky for Russian speakers: +{{count}} token for passing it',
      hardTitle_other: 'Tricky for Russian speakers: +{{count}} tokens for passing it',
      hardBadge: 'Tricky for Russian speakers — a token for passing it',
      forTopics_one: 'for {{count}} topic passed',
      forTopics_other: 'for {{count}} topics passed',
      forHard: 'for a tricky topic',
      title: 'Pass topics — earn tokens',
      hardRule_one: 'a topic tricky for Russian speakers gives +{{count}} more',
      hardRule_other: 'a topic tricky for Russian speakers gives +{{count}} more',
      howTo: 'A topic counts once its first exercise is done.',
    },
  },
  community: {
    title: 'Community',
    sub: 'Drop by: word breakdowns, Lomora news and live chat.',
    openAction: 'Open',
    telegram: {
      name: 'Telegram',
      desc: 'News, updates and short notes about words.',
    },
    vk: {
      name: 'VK',
      desc: 'Our VK community — posts and discussions.',
    },
    dzen: {
      name: 'Dzen',
      desc: 'Long-reads and breakdowns — practicing English and remembering words.',
    },
  },
  cardsWorkspace: {
    tabs: {
      label: 'How to create cards',
      dictionary: 'Word from the dictionary',
      dictionaryHint: 'Find a word and pick translations',
      dictionaryShort: 'Dictionary',
      topic: 'Words picked by topic',
      topicHint: 'AI picks 10–20 words for your topic',
      topicShort: 'By topic',
    },
    header: {
      eyebrow: 'Cards',
      inModule: 'to module {{title}}',
      titleAi: 'Create cards',
      newCards: 'New cards',
      in: 'in',
    },
    locked: {
      title: 'Confirm your email to create cards',
    },
    nav: {
      dashboard: 'Dashboard',
    },
    emptyModule: {
      title: 'Pick a module to see the queue',
      body: 'The card queue is built per module. Tap a module chip above — or create a new one right there.',
    },
    loadingQueue: 'Loading the card queue',
    appbar: {
      list: 'Cards',
      limitations: 'Limitations',
      composer: 'New card',
      ready: 'Card ready',
      garbage: 'Not recognized',
      problem: 'AI error',
    },
    aria: {
      back: 'Back',
      close: 'Close',
    },
    status: {
      manual: 'manual entry',
      generating: 'generating…',
      queued: 'queued',
      ready: 'ready',
      typo: 'typo?',
      garbage: 'not recognized',
      error: 'error',
    },
    filters: {
      all: 'All',
      manual: 'Manual',
      ai: 'AI-made',
      generating: 'Generating',
    },
    sections: {
      action_one: 'Waiting for you · {{count}}',
      action_other: 'Waiting for you · {{count}}',
      inflight_one: 'In progress · {{count}}',
      inflight_other: 'In progress · {{count}}',
      ready_one: 'Ready · {{count}}',
      ready_other: 'Ready · {{count}}',
    },
    pos: {
      noun: 'noun',
      verb: 'verb',
      'phrasal verb': 'phrasal verb',
      adjective: 'adjective',
      adverb: 'adverb',
      phrase: 'phrase',
      other: 'other',
      fallback: 'meaning',
    },
    list: {
      pickModuleTitle: 'Pick a module',
      pickModuleBody: 'The card queue is built per module. Tap a module chip above.',
      emptyTitle: 'Cards will appear here',
      emptyBody: 'Add your first one — AI will pick translations and examples.',
      createAi: 'Create with AI',
      createManual: 'Add manually',
    },
    picker: {
      eyebrow: 'Cards',
      title: 'Where to add?',
      subtitle: 'Pick a module — the queue and cards are built around it.',
      newModule: 'New module',
      empty: 'You have no modules yet — create your first one below.',
      loading: 'Loading modules…',
      wordsCount_one: '{{count}} word',
      wordsCount_other: '{{count}} words',
      switch: 'Switch module',
      create: {
        eyebrow: 'New module',
        namePlaceholder: 'e.g. Travel & Transport',
        descLabel: 'Description',
        descOptional: 'optional',
        descPlaceholder: 'what the module is about: e.g. trips, the airport and hotels',
        descHint: 'AI will write the card examples around this topic',
        pairLabel: 'Language pair',
        pairHint: 'Word in {{source}} → translation in {{target}}',
        cancel: 'Cancel',
        submit: 'Create and select',
        submitting: 'Creating…',
        error: 'Could not create the module. Try a different name.',
      },
    },
    compose: {
      ai: 'Dictionary',
      manual: 'Manual',
      hide: 'Hide',
      wordPlaceholder: 'english word',
      manualNote: 'Manual card: just word → translation',
      manualNoteDetail:
        'Without AI there is no hint, no “Missing word” exercise and no simple sentence for direct translation. Multiple choice, typo tolerance and meaning matching still work; transcription and part of speech come from the dictionary if the word is there.',
      hintAi: 'Enter — send to generation',
      hintManual: 'Enter — add card',
    },
    manual: {
      boxTitle: 'Word → your translation',
      wordLabel: 'Word',
      wordPlaceholder: 'start typing a word…',
      translationLabel: 'Translation',
      translationPlaceholder: 'type your translation',
      limitTitle: 'No AI — just the word and translation.',
      limitBody: 'No hint, meaning description or sentence exercises.',
      suggestHint: 'dictionary suggestions — click to fill the translation',
      pickTitle: 'Use “{{text}}” as the translation',
      notFound: 'Not in the dictionary: the card will have no transcription or part of speech. Type the translation yourself.',
      lookupError: 'The dictionary didn’t respond — type the translation yourself, the card will be created without it.',
      submit: 'Add',
      submitting: 'Creating…',
    },
    lookup: {
      spotlightPlaceholder: 'an English word, e.g. travel',
      searching: 'looking up…',
      createShort: 'create',
      count_one: '{{count}} translation',
      count_other: '{{count}} translations',
      more_one: '+{{count}} translation',
      more_other: '+{{count}} translations',
      notFoundTitle: 'Translation not found',
      notFoundHint: 'no dictionary entry — check the spelling or add manually',
      addManual: 'Add manually',
      error: 'Couldn’t check the translation — try again',
      pickHint: 'pick a part of speech — several is fine',
      createCount_one: 'Create card',
      createCount_other: 'Create {{count}} cards',
      alreadyAdded: 'already learning',
      generating: 'generating',
      needsAi: '+AI',
      needsAiHint: 'The ready card has no such part of speech — AI will add it (uses 1 credit)',
      allAdded: 'Every part of speech of this word is already added',
      allBusy: 'The other parts of speech are already added or generating',
      pos: {
        noun: 'noun',
        verb: 'verb',
        'phrasal verb': 'phrasal verb',
        adjective: 'adjective',
        adverb: 'adverb',
        pronoun: 'pronoun',
        preposition: 'preposition',
        conjunction: 'conjunction',
        numeral: 'numeral',
        particle: 'particle',
        interjection: 'interjection',
        phrase: 'phrase',
        other: 'other',
      },
      posShort: {
        noun: 'n.',
        verb: 'v.',
        'phrasal verb': 'phr. verb',
        adjective: 'adj.',
        adverb: 'adv.',
        pronoun: 'pron.',
        preposition: 'prep.',
        conjunction: 'conj.',
        numeral: 'num.',
        particle: 'part.',
        interjection: 'int.',
        phrase: 'phr.',
        other: 'other',
      },
    },
    choose: {
      inviteTitle: 'Choose what to learn',
      create_one: 'Create {{count}} card',
      create_other: 'Create {{count}} cards',
      pickSomething: 'Check what to learn',
      allAdded: 'Everything is added',
      // The price sits on the button (owner's rule); the summary shows what's left after it.
      createPaid_one: 'Create {{count}} card · 1 credit',
      createPaid_other: 'Create {{count}} cards · 1 credit',
      createOnePaid: 'Create card · 1 credit',
      checking: 'Checking…',
      // Non-breaking spaces keep "of 30" and "at 00:00 Moscow" together; a dash never starts a line.
      tokensLeft_one: '{{count}}\u00a0credit left of\u00a0{{limit}}',
      tokensLeft_other: '{{count}}\u00a0credits left of\u00a0{{limit}}',
      quotaOut: 'New credits at\u00a0{{time}}\u00a0Moscow time.',
      tokensBonus: 'from non-expiring\u00a0· {{count}} left',
      costExhausted: 'Out of credits',
      back: 'Back',
      clear: 'Clear',
      added_one: 'Added: {{count}} card',
      added_other: 'Added: {{count}} cards',
      error: 'The dictionary didn’t respond — you can still create the card, AI will analyse the word itself.',
      nothingToPickMobile: 'Every translation of this word is already learned or being created',
    },
    // Picking senses across the four dictionary sections (designs “Создание карточек v2”, 2026-10-06).
    pick: {
      searching: 'searching the dictionary…',
      eyebrow: 'Dictionary search',
      step1Title: 'Type a word', step1Text: 'the dictionary entry opens',
      step2Title: 'Tick translations', step2Text: 'the ones you want to learn',
      step3Title: 'Create cards', step3Text: '1 credit per 10 translations',
      stepsClose: 'Hide for good',
      stepsExample: 'Example: 4 translations of “run” ticked —', stepsExampleTotal: '1 credit',
      strip: 'Tick what to learn. The word and every phrase become separate cards.',
      yandex: 'from Yandex Dictionary',
      yandexShort: 'from Yandex Dictionary',
      noActiveRare: 'No main senses — this word is usually learned in a phrase',
      noActiveNone: 'No separate translation — pick a phrase',
      active: 'In active use',
      other: 'Other',
      rareSection: 'Rare',
      rareReadOnly: "Rarely used — they don't become cards. Add one manually if you need it.",
      titleRare: 'Rare sense — not added to cards',
      phrases: 'Phrases',
      phrasalVerbs: 'Phrasal verbs',
      selected: '{{n}} selected',
      rarePhrases: 'Phrases and phrasal verbs',
      peekClose: 'Close',
      more: '{{n}} more',
      less: 'collapse',
      tagLearned: 'learning',
      tagGenerating: 'creating',
      titleOn: 'Remove from selection',
      titleOff: 'Select this sense',
      titleLearned: 'You are already learning this sense',
      titleGenerating: 'This card is already being created',
      titleLimit: 'You can pick up to {{limit}} senses at once — untick another one',
      synonyms: 'Synonyms: ',
      rowLearned: 'You are already learning this phrase',
      rowSelect: 'Select — it becomes a separate card',
      rowShow: 'Show senses',
      rowHide: 'Collapse',
      moreSenses_one: '+{{count}} sense',
      moreSenses_other: '+{{count}} senses',
      willCreate_one: '{{count}} card will be created',
      willCreate_other: '{{count}} cards will be created',
      allLearned: 'All senses are already in your cards',
      nothing: 'Nothing selected',
      pickAbove: 'Tick senses above',
      count: '{{n}} of {{limit}}',
      countMax: '{{limit}} of {{limit}} · that is the maximum at once',
      countMaxShort: '{{limit}} of {{limit}} · maximum',
      moreCards: ' · {{n}} more',
      priceNone: 'No credit needed',
      priceNoneSub: 'the cards are ready',
      createOne: 'Create card',
      pickSense: 'Pick a sense',
      notFoundTitle: '“{{word}}” is not in the dictionary',
      notFoundBody: 'check the spelling or add a translation manually — the card will have no transcription, example or hint',
      addManual: 'Add manually',
      addManualHint: 'word → your translation, no AI',
      coachBold: 'Press and hold a sense',
      coachRest: ' to peek at its example without ticking it. Release to close.',
      coachHide: 'Got it, hide the tip',
      extraOther_one: 'other',
      extraOther_other: 'other',
      extraRare_one: 'rare',
      extraRare_other: 'rare',
      extraPhrases_one: 'phrase',
      extraPhrases_other: 'phrases',
      extraPhrasalVerbs_one: 'phrasal verb',
      extraPhrasalVerbs_other: 'phrasal verbs',
      inviteSub: 'senses, phrases and rare ones inside',
      skipped: 'Not created: {{list}} — already learning or not in the dictionary',
    },
    // Usage labels (Oxford), short.
    marks: {
      informal: 'informal',
      formal: 'formal',
      slang: 'slang',
      literary: 'literary',
      oldFashioned: 'dated',
      disapproving: 'disapproving',
      approving: 'approving',
      humorous: 'humorous',
      specialist: 'specialist',
      offensive: 'offensive',
      british: 'Br.',
      american: 'Am.',
      australian: 'Aus.',
      indian: 'Ind.',
      newZealand: 'NZ',
      southAfrican: 'SAfr.',
      scottish: 'Scot.',
      irish: 'Ir.',
      canadian: 'Can.',
      usuallyPlural: 'usually pl.',
      plural: 'pl.',
      uncountable: 'uncount.',
      beforeNoun: 'before noun',
      afterVerb: 'after a verb',
      usuallyPassive: 'usually passive',
      singular: 'sing.',
      transitive: 'trans.',
      intransitive: 'intrans.',
      countable: 'count.',
    },
    composer: {
      moduleLabel: 'Module',
      wordLabel: 'English word',
      wordHintAi: 'AI will pick translation options and examples',
      wordHintManual: 'no typo check or AI analysis',
      translationLabel: 'Translation',
      translationPlaceholder: 'aspiration',
      levelLabel: 'Level',
      submitting: 'Creating…',
      submitAi: 'Create card',
      submitManual: 'Add card',
    },
    generatingCount_one: 'Generating {{count}} card',
    generatingCount_other: 'Generating {{count}} cards',
    generatingSlow: 'more cards take longer — up to a couple of minutes',
    // One panel for every card being generated (2026-10-06).
    generation: {
      title: 'Generating',
      progress: '{{done}} of {{total}} ready',
      cards_one: '{{count}} card',
      cards_other: '{{count}} cards',
      status: {
        generating: 'generating',
        ready: 'ready',
        failed: 'failed',
      },
      remove: 'remove',
      allDone: 'All done',
      steps: ['Analysing the word', 'Choosing meanings', 'Writing examples', 'Translating sentences', 'Final check'],
    },
    ready: {
      badge: 'Ready to learn',
      manualPill: 'made manually',
      remove: 'Remove',
      openInModule: 'Open in module',
    },
    garbage: {
      heading: 'Word not recognized',
      fallbackMessage: 'This doesn’t look like an English word or phrase. Check for a typo and try again.',
      replaceWith: 'Replace with',
      placeholder: 'e.g. deployment',
      enterHint: 'Press Enter to replace, or use the button below',
      delete: 'Delete',
      replacing: 'Replacing…',
      replace: 'Replace',
    },
    problem: {
      heading: 'Generation error',
      fallbackMessage: 'AI couldn’t handle the generation. Try again.',
      delete: 'Delete',
      retry: 'Retry',
    },
    toast: {
      cardCreated: 'Card created',
      senseQueued: 'Added one more part of speech: {{front}} → {{translation}}. It arrives with the first one.',
      senseAdded: 'Added one more part of speech: {{front}} → {{translation}}',
      posQueued: 'Adding a part of speech: {{front}} → {{translation}}. We’ll notify you when it’s ready.',
      cardRemoved: 'Card “{{front}}” removed from the queue',
      cardHidden: 'Card “{{front}}” deleted — restore it from the “Deleted” tab',
      deleteFailedTitle: 'Couldn’t delete',
      deleteOldFailedTitle: 'Couldn’t delete the old card',
      alreadyInModuleTitle: '“{{front}}” is already in the module',
      alreadyInModuleDesktop: 'A card with this word is already here — find it at the bottom of the list.',
      alreadyInModuleMobile: 'A card with this word is already here — find it at the bottom of the list.',
      recreateFailed: 'We removed the old card, but couldn’t create the new one. Add it again.',
      fixAppliedTitle: 'Fix applied',
      fixAppliedDesc: '“{{front}}” → “{{newFront}}”. Regenerating.',
      keptTitle: 'Kept as is',
      keptDesc: 'Card “{{front}}” saved in the module unchanged.',
      retrying: 'Regenerating “{{front}}”…',
      retryingShort: 'Retrying “{{front}}”…',
      regenStartedTitle: 'Generation started',
      regenStartedDesc: 'AI will analyze “{{front}}” — there will be several meanings and an example.',
      errorTitle: 'Error',
      feedbackThanksTitle: 'Thanks for the feedback',
      feedbackThanksDesc: 'We received your report on “{{front}}” — we’ll look into what’s wrong.',
      cardSavedTitle: 'Card saved',
      cardSavedDesc_one: '“{{front}}” — {{count}} translation.',
      cardSavedDesc_other: '“{{front}}” — {{count}} translations.',
      creating: '“{{front}}” is being created…',
      wordReplacedTitle: 'Word replaced',
      wordReplacedDesc: '“{{front}}” → “{{trimmed}}”. Regenerating.',
    },
    errors: {
      emptyFields: 'Fill in both fields',
      alreadyAdded: 'The word is already in one of your modules',
      alreadyAddedShort: 'The word is already in this module',
      alreadyAddedIn_one: 'The word is already in the module {{names}}',
      alreadyAddedIn_other: 'The word is already in the modules {{names}}',
      dailyLimit: 'You’re out of credits for today',
      dailyLimitDetailed: 'You’re out of credits for today. Create cards manually or upgrade your plan.',
      dailyLimitQuota: 'You’re out of credits for today ({{used}}/{{limit}}). New ones arrive at {{time}} — meanwhile you can create cards manually.',
      dailyLimitRegen: 'You’re out of credits for today — new ones arrive tomorrow, or upgrade your plan.',
      notInDictionary: 'This word isn’t in the dictionary — we can’t prepare a card, and no credit is used. Check the spelling or add the card manually.',
      // 400 NOT_IN_DICTIONARY on “Try again” (spec § 23.5): the card already exists, no credit was used.
      regenNotInDictionary: 'This word isn’t in the dictionary — it can’t be retried, and no credit was used. Add the card manually.',
      generationInProgress: 'This word is still generating. Wait a few seconds and add the part of speech again — no credit was used.',
      // 409 CARD_GENERATION_IN_PROGRESS on a manual card (spec § 23.1): dashboard and /cards/new.
      generationInProgressManual: 'This word is already being created in this module. If it fails, you can add it manually.',
      rateLimit: 'Too many requests in a row — wait a minute.',
      moduleNotFound: 'This module was deleted — pick another one.',
      emailNotVerified: 'Confirm your email first — the link is in the email.',
      serverUncertain: 'The server didn’t respond — check the list before creating again.',
      network: 'No connection to the server',
      networkRetry: 'No connection to the server — try again later.',
      tryAgain: 'Try again.',
      unknownCreate: 'Couldn’t create the card',
      deleteFailedShort: 'Couldn’t delete',
      deleteOldFailedShort: 'Couldn’t delete the old card.',
      createNewFailed: 'Couldn’t create the new card.',
      notRegeneratable: 'The card is already being processed by AI or is ready — nothing to regenerate.',
      notInAccount: 'This card isn’t in your account.',
      regenFailed: 'Couldn’t start regeneration.',
      storyWordsAiLimit: 'AI cards from the game are used up for today — try again tomorrow or add the card manually. No credit was used.',
      notReportable: 'This card can’t be flagged as a “wrong translation” — it isn’t ready yet.',
      notFoundInAccount: 'Card not found in your account.',
      reportFailed: 'Couldn’t submit the report. Try again.',
    },
  },
  triage: {
    status: {
      typo: 'Typo',
      garbage: 'Not recognized',
      error: 'Error',
      aiError: 'AI error',
      awaitingSelection: 'Pick translations',
    },
    row: {
      delete: 'Delete',
      deleteCard: 'Delete card',
      suggestions: 'suggestions:',
      retry: 'Retry',
      placeholderCorrectWord: 'correct word',
      placeholderFix: 'fix',
      replace: 'Replace',
      apply: 'Apply',
    },
    awaiting: {
      savesToModule: 'Will be saved to module:',
      alsoIn_one: 'card is also in {{count}} other',
      alsoIn_other: 'card is also in {{count}} others',
    },
    empty: {
      title: 'Queue is empty',
      resolvedPrefix: "You've sorted out",
      resolvedSuffix_one: '{{count}} card — great work.',
      resolvedSuffix_other: '{{count}} cards — great work.',
      back: '← Back to cards',
    },
    toast: {
      moduleUnknown: "Couldn't determine the card's module.",
      noConnection: 'No connection to the server — try again later.',
      tryAgain: 'Please try again.',
      deleteOldFailed: "Couldn't delete the old one",
      removeOldFailed: "Couldn't remove the old one",
      deleteFailed: "Couldn't delete",
      alreadyInModuleTitle: '“{{word}}” is already in the module',
      alreadyInModuleMessage: 'A card with this word was already added earlier — open the module and work with it.',
      replaceCreateFailed: "We removed the old one, but couldn't create the new one. Add it again.",
      retryGenFailed: "We removed the old one, but couldn't retry generation.",
      savedTitle: 'Translations saved',
      savedMessage: 'Selected {{count}} for “{{word}}”.',
      saveStateNotFound: 'Card not found in your progress.',
      saveWrongCard: "Some translations don't belong to this card.",
      saveFailed: "Couldn't save translations. Please try again.",
      saveErrorTitle: 'Save error',
    },
    header: {
      backToCards: '← Cards',
      eyebrow: 'Queue triage',
      title: 'Cards waiting for a decision',
      sub: 'All typos and unrecognized words from all your modules in one place. Fix them — Enter applies, clicking a suggestion fills it into the input.',
    },
    progress: {
      label: 'Progress',
      remaining: 'remaining',
      allDone: 'all sorted out',
    },
    filter: {
      allModules: 'All modules',
    },
    hints: {
      apply: 'apply',
      clickSuggestion: 'click a suggestion to fill it in',
    },
  },
  notifications: {
    title: 'Notifications',
    batchReady_one: '{{count}} card is ready',
    batchReady_other: '{{count}} cards are ready',
    batchMore_one: '{{list}} and {{count}} more',
    batchMore_other: '{{list}} and {{count}} more',
    sub: 'All recent events — from the system and your learning.',
    unreadCount_one: '{{count}} unread',
    unreadCount_other: '{{count}} unread',
    allRead: 'All read',
    markAllRead: 'Mark all as read',
    hideAll: 'Hide all',
    hideAllConfirm: 'Hide all? Click again',
    filters: {
      all: 'All',
      unread: 'Unread',
      read: 'Read',
    },
    loadingMore: 'Loading…',
    empty: {
      title: 'All quiet here',
      sub: 'Notifications will appear when something happens — a finished session, a module update, system messages.',
    },
    emptyUnread: 'No unread notifications.',
    emptyRead: 'No read notifications yet.',
    error: 'Could not load notifications. Try refreshing the page.',
    item: {
      unreadDot: 'unread',
      open: 'Open',
      markRead: 'Mark as read',
      hide: 'Hide',
    },
    relativeNow: 'just now',
    relativeMin_one: '{{count}} min ago',
    relativeMin_other: '{{count}} min ago',
    relativeHour_one: '{{count}} h ago',
    relativeHour_other: '{{count}} h ago',
    relativeDay_one: '{{count}} day ago',
    relativeDay_other: '{{count}} days ago',
  },
  emptyModules: {
    full: {
      kicker: 'Nothing here yet',
      title: 'Create your first module',
      body: 'Add your own set of words or pick a ready-made module from the library for your first practice session.',
      cta: 'Create module',
      secondary: 'Open ready-made',
    },
    locked: {
      kicker: 'Nothing here yet',
      title: 'Confirm your email to create your own modules',
      titleDock: 'Start with a ready-made module',
      body: 'Add a ready-made module from the library and start your first practice session.',
      cta: 'Open ready-made modules',
    },
    // Demo fixes spec 1.4 (B3, R9): deleted modules can be restored; one deleted — moduleDetail.restore.*.
    restore: {
      // The name ends the sentence: after a clamped two-line name the next line starts with a word (A2-04).
      body: 'In Deleted: “{{name}}”. Its cards and progress are saved.',
      busy: 'Restoring…',
      kickerMany: 'Modules deleted',
      titleMany: 'Deleted modules can be restored',
      bodyMany: 'Their cards and progress are saved.',
      ctaMany: 'Open deleted',
    },
  },
  // Module word list with a card (entities/Word · WordBrowser).
  wordBrowser: {
    card: 'Card',
    prev: 'Previous card',
    next: 'Next card',
    sheetPrev: '← Back',
    sheetNext: 'Next →',
    close: 'Close',
    keysHint: 'flip through cards',
    meaning: 'Meaning',
    example: 'Example',
    hint: 'Hint',
    rare: 'Rare',
  },
  // A card is a word or a phrase; a translation inside it is a «translation» (owner, 2026-10-20, spec § 22.13).
  sessionSenses: {
    pill_one: '{{count}} translation',
    pill_other: '{{count}} translations',
    pillTitle: 'Each translation is a separate task in practice',
    title: 'Translations · {{total}}',
    remove: 'Delete translation',
    removeLast: 'Last translation — the word will be removed from the module',
    removeConfirm: 'Delete?',
    removeWordConfirm: 'Remove word?',
    more_one: 'Show {{count}} more translation',
    more_other: 'Show {{count}} more translations',
    collapse: 'Collapse',
    otherTitle: 'Rare translations · {{count}}',
    otherNotePanel: 'Not in practice',
    definitionLabel: 'Meaning',
    definitionTitle: 'What the word means in this translation. Practice shows it after the answer',
    saveError: 'Could not delete the translation — try again',
  },
  library: {
    searchPlaceholder: 'Search by name or description…',
    official: 'By Lomora',
    community: 'From the community',
    moduleCount_one: '{{count}} module',
    moduleCount_other: '{{count}} modules',
    cardCount_one: '{{count}} card',
    cardCount_other: '{{count}} cards',
    installCount_one: '{{count}} install',
    installCount_other: '{{count}} installs',
    role: {
      official: 'Lomora team',
      community: 'Community',
    },
    verified: 'Made by the Lomora team',
    add: 'Add',
    addNamed: 'Add “{{name}}”',
    addedShort: '✓ Added',
    addedToast: '“{{name}}” is now in your modules',
    fork: 'Add to my modules',
    added: '✓ Already added',
    forkError: 'Could not add the module. Try again.',
    share: 'Share',
    shareDone: '✓ link copied',
    empty: 'Nothing matched your search — try a different query.',
    emptyAll: 'No ready-made modules yet — coming soon. Meanwhile you can add your own words in “My modules”.',
    detail: {
      back: 'all ready-made modules',
      cardsHeading: 'Cards in the module · {{n}}',
      noCards: 'This module has no cards yet.',
      notFound: 'Ready-made module not found',
      pickHint: 'Click a word to open its card on the right',
    },
  },
  dashboard: {
    greeting: 'Good\u00a0day, {{name}}',
    greetingSub: 'Here’s what you can do today.',
    donorBadge: 'Project supporter',
    // Tour after the introduction (DashboardTour): three steps over the sections; step titles are the sections' own labels.
    tour: {
      counter: '{{n}} of {{total}}',
      next: 'Next',
      done: 'Got it',
      skip: 'Skip',
      home: 'What to do today: practice, the daily task and the mission.',
      words: 'Your modules and ready-made sets. This is also where you create new cards — in the bar below.',
      grammar: 'English rules step by step: read one, then practise right away. Exercises earn stars.',
      game: 'Voice conversations with Londoners. Missions earn you tokens.',
    },
    active: {
      kicker: 'Practice in progress',
      bossReady: 'Only the final match is left',
      bossSub: 'Match the words you’ve covered into pairs.',
      toFinal: 'Go to the finale',
      remaining_one: '{{count}} card left',
      remaining_other: '{{count}} cards left',
      redoInline: '{{count}} to redo',
      continue: 'Continue practice',
    },
    kpis: {
      streak: { title: 'Streak', sub_one: 'day in a row', sub_other: 'days in a row' },
      words: { title: 'Words in memory', sub: '+{{n}} this week' },
      accuracy: { title: 'Accuracy', sub: 'over the last 7 days' },
      today: { title: 'Today', sub_one: '{{n}} word to goal', sub_other: '{{n}} words to goal' },
    },
    modules: {
      chips: {
        deleted: 'deleted',
      },
    },
    // The new dashboard (owner’s mock-up “3 · Dashboard”, 2026-10-22).
    home: {
      reminder: {
        title: 'Reminders are off',
        text: 'Turn them on — we’ll send a short email at {{hour}}:00 Moscow time if you haven’t practised for a while.',
        on: 'Turn on',
        later: 'Later',
        saved: 'Reminders are on',
        error: 'Couldn’t turn reminders on. Try again.',
      },
      game: {
        play: 'Play',
        resume: 'Continue playing',
        kicker: 'Survive London',
        kickerDay: 'Survive London · day {{day}}',
        chapter: 'chapter {{no}}',
        day: 'day {{day}}',
        hunger: 'Fullness',
        title: 'Survive London',
        energy: 'energy {{left}}/{{max}}',
        hungry: 'time for a snack',
        pitch: 'A game: talk to Londoners in English',
        endings: 'Endings:\u00a0{{n}} of\u00a0{{total}}',
        boss: 'Mistakes for the boss:\u00a0{{count}}',
      },
      mission: {
        upTo_one: 'up to +{{count}} credit',
        upTo_other: 'up to +{{count}} credits',
        noReward: 'No credits earned',
      },
      planHint: {
        kicker: 'Plan',
        tokens: 'No tokens left today',
        tokensNext: 'New at midnight. {{plan}} gives {{limit}} tokens a day',
        energy: 'No energy left in the game',
        energyNext: 'New at midnight. {{plan}} gives {{limit}} replies a day',
        midnight: 'New at midnight',
      },
      dailies: {
        tokens: 'tokens today: {{got}} of {{can}}',
        title: 'Today',
        take: 'Get',
        taking: 'Picking…',
        learn: 'Learn',
        start: 'Start',
        starting: 'Preparing…',
        resume: 'Continue',
        result: 'Results',
        steps: 'Step {{n}} of {{total}}',
      },
      create: {
        title: 'Came across a new word?',
        text: 'Save it as a card — we’ll find the translation and an example.',
        card: 'Create a card',
        module: 'New module',
      },
      createRow: {
        link: 'New word to cards',
        title: 'Your own word to cards',
        button: 'Create your own card',
        placeholder: 'e.g. umbrella',
        short: 'Create',
        text: 'We’ll find the translation and an example.',
        action: 'Create a card',
      },
      grammar: {
        kicker: 'Grammar',
        left_one: '{{count}} more topic to a reward',
        left_other: '{{count}} more topics to a reward',
        reward_one: '+{{count}} token',
        reward_other: '+{{count}} tokens',
        ofStep: '{{done}} of {{step}}',
        hint: 'Any order. A topic counts after exercise 1.',
        plain: 'Learn grammar topic by topic',
        allDone: 'All topics done',
        continue: 'Continue: {{title}}',
        start: 'Start: {{title}}',
        all: 'All topics',
      },
    },
  },
  units: {
    title: 'Modules',
    summaryLoading: 'loading modules…',
    totalCount_one: '{{count}} module',
    totalCount_other: '{{count}} modules',
    searchPlaceholder: 'Search by name…',
    createModule: 'Create module',
    empty: 'Nothing matches the filter',
    filters: {
      all: 'All',
      active: 'Active',
      paused: 'Paused',
      deleted: 'Deleted',
    },
    deletedNotice: 'Deleted modules are kept here. You can restore any of them with its cards and progress.',
  },
  words: {
    title: 'Words & modules',
    sub: 'Your modules and all your words. Add new words in the bar below.',
    subLocked: 'Your modules and all your words.',
    composerTitle: 'Create a card',
    modulesTitle: 'All modules',
    readyTitle: 'Ready-made sets',
    guestCardHint: 'Your first card is ready right away; the next ones open once you confirm your email.',
    readyLink: 'Ready-made word sets',
    trainError: 'Couldn’t start the practice. Try again.',
    shelf: {
      title: 'Modules',
      all: 'All',
      newModule: 'New module',
      ready: 'Ready-made sets',
    },
    list: {
      title: 'Words',
      find: 'Search',
      search: 'Word or translation',
      cancel: 'Cancel',
      filterLabel: 'Which words to show',
      kinds: {
        all: 'All',
        new: 'New',
        repeat: 'To review',
      },
      status: {
        new: 'new',
        repeat: 'review',
        today: 'today',
      },
      hint: 'Tap a word to see an example, its meaning and all translations.',
      rowAria: '{{word}}: {{translations}}, module “{{module}}”. Open details',
      empty: 'Your words will appear here. Add the first one in the bar below\u00a0— we’ll show where it went.',
      noMatch: 'Nothing found',
      moduleEmpty: 'No words in this module yet.',
      allWords: 'Show all words',
      openModule: 'Open module',
      cols: {
        word: 'Word',
        translation: 'Translation',
        module: 'Module',
        status: 'Status',
      },
      loadError: 'Words didn’t load.',
      retry: 'Retry',
      more: 'Show more',
      loading: 'Loading…',
    },
    toolbar: {
      all: 'All words',
      searchIn: 'Search this module',
      empty: 'No words yet\u00a0— add the first one in the bar below',
    },
    sheet: {
      kicker: 'Module “{{module}}”',
      openModule: 'Open module',
    },
    mine: {
      repeat_one: 'Review {{count}} word',
      repeat_other: 'Review {{count}} words',
      train: 'Learn “{{name}}”',
      trainTitle: 'Today’s practice',
      learn: 'Learn',
      select: 'Show words of “{{name}}”',
      fresh_one: '{{count}} new · today',
      fresh_other: '{{count}} new · today',
    },
    progress: {
      title: 'Your progress',
      passed_one: 'word covered',
      passed_other: 'words covered',
      ofReady_one: 'out of {{count}} word in your modules',
      ofReady_other: 'out of {{count}} words in your modules',
      empty: 'Add words to a module — you’ll see here how many you’ve covered.',
      today: 'Today',
      accuracy: 'Accuracy, 7 days',
      line_one: '{{passed}} of\u00a0{{count}} word covered',
      line_other: '{{passed}} of\u00a0{{count}} words covered',
      lineAccuracy: 'accuracy\u00a0{{value}}%',
    },
  },
  moduleDetail: {
    backToUnits: 'all modules',
    notFound: 'Module not found',
    kicker: 'your set of words',
    active: 'active',
    paused: 'paused',
    visibility: {
      public: 'Public',
      private: 'Private',
      publicHint: 'Visible to other users in “Ready-made”',
      privateHint: 'Visible only to you',
    },
    share: {
      cta: 'Share',
      copying: '…',
      done: 'Copied',
      privateBlocked: 'Make the module public first',
      toastTitle: 'Link copied',
      toastBody: 'Paste it into a chat, email or social media.',
      toastError: 'Could not copy the link',
    },
    menu: {
      aria: 'Module actions',
      delete: 'Delete module',
    },
    danger: {
      confirmKicker: 'Deletion',
      confirmTitle: 'Delete “{{name}}”?',
      confirmBody:
        'The module will go to the “Deleted” section. You can bring it back from there with its cards and progress.',
      confirmCta: 'Yes, delete',
      cancel: 'Cancel',
      error: 'Could not delete. Try again.',
      toastTitle: 'Module deleted',
      toastBody: '“{{name}}” moved to “Deleted”. You can restore it any time.',
    },
    restore: {
      kicker: 'Module deleted',
      title: 'You can bring it back',
      body: 'Restore it to practice again — the cards and progress are kept.',
      inTraining: 'The module “{{name}}” is deleted. Restore it to practice — the cards and progress are kept.',
      cta: 'Restore module',
      error: 'Could not restore. Try again.',
      toastTitle: 'Module restored',
      toastBody: '“{{name}}” is available again. Card progress is preserved.',
    },
    studyThis: 'Start practice',
    cram: 'Practice',
    cramTooltip:
      'Choose exercises and module cards, practice and play the final matching round.',
    acquaint: 'Preview',
    cramHero: {
      kicker: 'Practice',
      title: 'Practice this module’s words',
      sub: 'Choose exercises and cards, then start practice.',
    },
    kpis: {
      progress: { title: 'Progress', sub_one: '{{n}} word total', sub_other: '{{n}} words total' },
      learned: { title: 'Learned', sub: 'of {{n}}' },
      inReview: { title: 'In review', sub: 'in the active cycle' },
    },
    words: {
      title_one: 'Word in the module · {{n}}',
      title_other: 'Words in the module · {{n}}',
      createCard: 'Create card',
      createShort: 'Create',
      search: 'search…',
      empty: 'Nothing found',
      filters: {
        all: 'All',
        hidden: 'Deleted',
        review: 'To review',
        new: 'New',
        learned: 'Learned',
      },
      hide: 'Delete from module',
      restore: 'Restore',
      resolve: 'Resolve',
      needActionText: 'We couldn’t parse this word automatically — take a look and decide what to do.',
      hidden: '"{{word}}" deleted',
      restored: '"{{word}}" restored',
      actionFailed: 'Something went wrong. Try again',
      chips: {
        review: 'to review',
        new: 'new',
        learned: 'learned',
        needAction: 'needs action',
      },
      dot: {
        manual: 'created manually',
        ready: 'ready',
      },
      moreSenses: ' · +{{count}}',
      pos: {
        noun: 'n.',
        verb: 'v.',
        'phrasal verb': 'phr. verb',
        adjective: 'adj.',
        adverb: 'adv.',
        phrase: 'phr.',
        other: 'other',
      },
      senses: {
        more_one: '+{{count}} meaning',
        more_other: '+{{count}} meanings',
        kicker_one: '{{count}} meaning',
        kicker_other: '{{count}} meanings',
        example: 'Example',
      },
    },
    needActionBanner: {
      title_one: '{{count}} card needs action',
      title_other: '{{count}} cards need action',
      body: 'The algorithm couldn’t parse these words automatically — take a look and decide what to do.',
      cta: 'Open',
    },
  },
  preview: {
    back: 'module',
    kicker: 'preview',
    of: 'of',
    tag: { word: 'word', translation: 'translation' },
    show: { word: 'Show word', translation: 'Show translation' },
    hide: 'Hide',
    hint: {
      showWord: 'Space or click — show word',
      showTranslation: 'Space or click — show translation',
      backToWord: 'click — back to word',
      backToTranslation: 'click — back to translation',
    },
    footnote: 'Flip through the cards to get to know the words.',
    toCram: 'Go to practice →',
    prev: 'back',
    next: 'next',
    loading: 'Loading…',
    manual: {
      badge: 'manual',
      note: 'This card was created manually — it has no examples, meaning or hint that AI cards have; the transcription comes from the dictionary if the word is there.',
      aria: 'Created manually, limited card',
    },
    done: {
      title_one: '{{count}} card reviewed',
      title_other: '{{count}} cards reviewed',
      sub: 'Now practice the words or flip through them again.',
      again: 'Again',
      toCram: 'To practice →',
    },
    empty: {
      title: 'No ready cards in this module yet',
      sub: 'Cards will appear here once the words are generated.',
      back: '← back to module',
    },
  },
  actionRequired: {
    backToModule: 'to the module',
    kicker: '“{{module}}”',
    title: 'Need action',
    sub_one: '{{count}} problem card — decide what to do.',
    sub_other: '{{count}} problem cards — decide what to do.',
    subEmpty: 'Empty here — all the cards in the module parsed without issues.',
    empty: {
      title: 'Nothing needs action',
      sub: 'When the algorithm can’t parse a word — the card shows up here.',
    },
    row: {
      chip: 'needs action',
      chipTypo: 'possible typo',
      reason: 'What’s wrong',
      suggestions: 'Pick the correct option',
      hint: 'Or apply an action below.',
      keep: 'Keep as is',
      edit: 'Edit',
      delete: 'Delete',
    },
    toasts: {
      keptTitle: 'Action saved',
      keptBody: '“{{word}}” kept as is. The backend for this action isn’t wired up yet.',
      editTitle: 'Editing',
      editBody: 'Opening the editor for “{{word}}” isn’t wired to the backend yet.',
      deleteTitle: 'Deletion',
      deleteBody: 'Deleting “{{word}}” isn’t wired to the backend yet.',
      applyTitle: 'Replacement',
      applyBody: 'Replacing “{{from}}” with “{{to}}” isn’t wired to the backend yet.',
    },
  },
  cram: {
    kicker: 'Practice',
    loadError: 'Could not load practice.',
    retry: 'Try again',
    noCards: 'Add ready cards to the module to start practice.',
    resumeTitle: 'Practice session saved',
    resumeFinal: 'Only the finale remains — match the words in pairs.',
    resumeRemaining: '{{count}} cards left. Continue where you stopped.',
    resume: 'Continue practice',
    changeSetup: 'Build a new session',
    replaceNote: 'Starting a new session will replace this module’s saved practice session.',
    title: 'What do we run?',
    intro:
      'Choose the exercises and cards for this practice session.',
    note: 'Practice at your own pace. You can finish a session early.',
    startError: 'Could not start the practice. Try again.',
    wip: 'In progress',
    builder: {
      back: 'back to module',
      starting: 'Starting…',
      title: 'Your kind of practice',
      sub: 'Choose a preset or make it your own. Your session is ready to go.',
      filters: {
        label: 'Card filter',
        today: 'For today',
        all: 'All cards',
        mistakes: 'With mistakes',
        frequent: 'Most mistakes',
        manual: 'Picked manually',
        mistakesHint: 'Cards answered incorrectly in this module’s practice sessions, including mistakes you later corrected.',
        frequentHint: 'The selection prioritises cards with the most mistakes. Choose how many to practise.',
        loading: 'Loading mistake history…',
        loadError: 'Could not load mistake history.',
        emptyTitle: 'No cards with mistakes yet',
        emptyBody: 'Cards will appear here after incorrect answers in practice sessions.',
        showAll: 'Use all cards',
      },
      setup: {
        format: 'How to practise',
        formats: 'Formats',
        cardsShort: 'Cards',
        pickedOf: '{{count}} of 4 picked',
        nonePicked: 'nothing picked',
        manualNote:
          'Cards you created manually only show up in direct and reverse translation (without a hint) and in pick-the-word: they have no AI-generated context, hint or meaning description.',
        finalMatch: 'Final match',
        finalMatchDesc: 'end by matching every word with its translation',
        finalMatchOff: 'no final match',
        previewLabel: 'What the exercise looks like',
        manualShort: 'Manual',
        cards: 'Which cards to include',
        restore: 'Same as last time',
        customize: 'Customise exercises',
        customizeHint: 'Choose exercise formats',
        expand: 'Open',
        collapse: 'Hide',
        exerciseCount_one: '{{count}} format',
        exerciseCount_other: '{{count}} formats',
        exerciseHelp: 'Choose one or more formats. Exercises will appear in a random order.',
        availability: 'Context needs an example; multiple choice needs options. Cards without them use another available format.',
        amount: 'Number of cards',
        all: 'All',
        allCards: 'All cards in the module · {{count}}',
        available: '{{count}} in this module',
        chooseCards: 'Choose cards',
        shuffleCards: 'Different cards',
        selectedCards: 'Selected cards',
        showAllSelected: 'View all selected cards',
        limit: 'Up to {{count}} cards per session. You can pick specific cards yourself.',
        summary: 'Your session',
        distributionNote: 'One format per card. Your selected exercises appear in a random order.',
        flowPractice: 'Practise at your own pace',
        flowRepeat: 'Revisit any mistakes you make',
        flowMatch: 'Finish by matching pairs',
        saveNote: 'We’ll remember this setup when you start.',
        presets: {
          warmup: { title: 'Warm-up', short: 'Warm-up', desc: 'Recognise words and translate into Russian.', caption: 'Multiple choice + translation' },
          balanced: { title: 'All exercises', short: 'Everything', desc: 'Practise words from different angles.', caption: 'All 4 formats' },
          challenge: { title: 'Challenge', short: 'Challenge', desc: 'Recall and type the English words.', caption: 'Reverse translation + context' },
          custom: { title: 'Custom mix', short: 'Custom' },
        },
      },
      ex: {
        input: {
          title: 'Direct translation',
          desc: 'see the word — type the translation',
          pair: 'EN → RU',
          rule: 'A simple sentence with the word highlighted — translate it into Russian. Manual cards show just the word. A one-letter typo and a synonym count; a translation of another meaning counts too, with a note.',
        },
        reverse: {
          title: 'Reverse translation',
          desc: 'see the translation — type the word',
          pair: 'RU → EN',
          rule: 'The translation is large, the word is hidden. The hint opens the first letter — no explanation here.',
        },
        mcq: {
          title: 'Pick the word',
          desc: 'choose the correct option',
          pair: '4 options',
          rule: 'Four options, keys 1–4. No “no idea” here — the answer is already on screen. A miss highlights the right option.',
        },
        cloze: {
          title: 'Missing word',
          desc: 'fill the word into a sentence',
          pair: 'context',
          rule: 'A sentence with a gap. Answer in English. Hint: the first letter and the meaning. Afterwards only the meaning opens — the example was the question.',
        },
      },
      preview: {
        label: 'session makeup',
        cardsNoun_one: 'card',
        cardsNoun_other: 'cards',
        even: 'evenly across types',
        single: 'whole session, one type',
        random: 'random order',
        randomLegend: 'random across all 4 types',
      },
      empty: 'Pick at least one exercise.',
      emptyCards: 'Pick at least one card.',
      start: 'Start practice',
      startHint: 'Pick exercises',
      loading: 'Loading your setup…',
      compose: {
        title: 'Card set',
        all_one: 'all {{count}} card in the module',
        all_other: 'all {{count}} cards in the module',
        none: 'none — pick some cards',
        subset: '{{n}} of {{total}} cards',
        change: 'Change',
      },
      picker: {
        title: 'Session set',
        sub: 'Choose up to {{max}} cards. Your changes are saved when you select Apply.',
        cancel: 'Cancel',
        apply: 'Apply',
        selectVisible: 'Select matches',
        limit: 'Choose up to {{max}} cards per session.',
        limitReached: '{{max}} cards selected. Remove one to add another.',
        selectAtLeastOne: 'Choose at least one card.',
        presetUpTo: 'First {{n}}',
        mistakes: 'Mistakes: {{count}}',
        close: 'close',
        search: 'search by word or translation…',
        presetAll: 'Select all',
        presetFirst: 'First {{n}}',
        presetLast: 'Last {{n}}',
        presetNone: 'Clear all',
        empty: 'Nothing found',
        ofTotal: 'of {{total}} selected',
        done: 'Done',
      },
    },
  },
  session: {
    streak_one: 'day streak',
    streak_other: 'day streak',
    comboRun: '{{count}} in a row',
    exitShort: 'exit',
    finishShort: 'finish',
    // “Finish” on the second press (demo fixes spec 1.6): the label after the first one.
    finishConfirm: 'finish?',
    finishDialogTitle: 'Finish this practice?',
    finishDialogBody: 'Your answers are saved, but you won’t be able to continue this practice.',
    finishDialogYes: 'Finish',
    finishDialogNo: 'Keep going',
    finishing: 'Finishing…',
    finishError: 'Could not finish the training. Try again.',
    // The answer wasn’t sent (categorizeAnswerError, B13): the line above the stage.
    answerError: {
      network: 'No connection — your answer wasn’t sent. Send it again once you’re back online.',
      reconnected: 'You’re back online — send your answer again.',
      server: 'The server couldn’t take your answer. Try again.',
      unknown: 'Couldn’t send your answer. Try again.',
      desync: 'This practice changed in another tab — reloading…',
      tooLong: 'That’s too long — type a word or a short phrase.',
      rateLimited: 'Too fast. Wait {{n}}\u00a0s and try again.',
      rateLimitedShort: 'Too fast. Wait a moment.',
      checkUnavailable: 'Answer checking is briefly unavailable. Send it again in a couple of seconds.',
    },
    completeError: 'Could not save the results. Try saving again.',
    retryComplete: 'Save results',
    loading: 'Loading the session…',
    emptyTitle: 'Training not found',
    emptySub: 'Pick a module and start a new training.',
    errorTitle: 'Could not load the session',
    exit: 'Exit',
    progressTitle: 'card {{current}} of {{total}}',
    manualNote: {
      title: 'This card was added manually',
      body: 'Without AI it has no hint, no example sentence and no simple sentence to translate — so its exercises use only the word.',
    },
    task: {
      input: 'translate into Russian',
      inputWord: 'translate the highlighted word',
      reverse: 'recall the English word',
      mcq: 'pick the translation',
      cloze: 'fill the gap',
    },
    typeTranslation: 'translation…',
    typeTranslationWord: 'word translation…',
    typeWordEn: 'the English word…',
    checkBtn: 'Check',
    // The verdict takes longer than 1.2 s (meaning check), demo fixes spec 1.7.
    checkingLong: 'Checking your answer…',
    dontKnow: 'no idea',
    hint: {
      show: 'hint',
      firstLetter: 'first letter',
      startsWith: 'starts with “{{letter}}”',
    },
    legend: {
      typed: 'Enter — check · Tab — hint · Esc — no idea',
      reverse: 'Enter — check · Tab — first letter · Esc — no idea',
      mcq: '1–4 — pick · Tab — hint',
    },
    verdict: {
      ok: 'correct',
      typo: 'correct, with a typo',
      semantic: 'correct by meaning',
      gaveUp: 'no idea · comes back later',
      wrong: 'incorrect · comes back later',
    },
    feedback: {
      continue: 'Continue',
      correctIs: 'correct',
      offSense: 'Looks like you are learning another meaning:',
      contextNote: 'Counted, but in this sentence {{word}} means “{{expected}}”, not “{{matched}}”',
      contextNoteShort: 'Counted, but in this sentence {{word}} means “{{expected}}”',
      wholeSentence: 'Counted! Here it’s enough to translate just the highlighted word: {{word}} — “{{expected}}”',
    },
    boss: {
      eyebrow: 'final round',
      title: 'Match the pairs',
      intro_one: '{{count}} word from this training. Match it with its translation as fast as you can.',
      intro_other: '{{count}} words from this training. Match each one with its translation as fast as you can.',
      step1: 'word on the left',
      step2: 'translation on the right',
      step3: 'the pair disappears',
      start: 'Start',
      taskLeft: 'pick a word on the left',
      taskRight: 'now the translation on the right',
      hit: 'matched',
      missed: 'not that one — try again',
      allDone: 'done — every pair matched',
      foot: 'click a word, then its translation · a miss costs nothing but breaks a clean round',
    },
    complete: {
      kicker: 'training finished',
      minutes: '{{count}} min',
      headlineClean: 'Clean.',
      headlineGood: 'Good work.',
      headlineWork: 'Room to grow.',
      subReturn_one: '{{count}} word comes back in the next training',
      subReturn_other: '{{count}} words come back in the next training',
      subPerfect: 'every word on the first try — keep it up',
      accuracy: 'accuracy',
      answers: 'answers',
      wrong: 'mistakes',
      bestRun: 'best run',
      bossLine: 'final round: {{clean}} of {{total}} without a miss · {{seconds}}s',
      mistakes: 'got these wrong',
      mistakesTitle_one: '{{count}} word with a mistake',
      mistakesTitle_other: '{{count}} words with mistakes',
      showAll: 'See all · {{count}}',
      done: 'Done',
    },
  },
  stats: {
    title: 'Statistics',
    sub: 'Progress over all your learning.',
    kpis: {
      total: { k: 'Total words', v: '847', s: 'B2 · 68% coverage' },
      avg: { k: 'Average accuracy', v: '92%', s: 'over 7,280 answers' },
      hours: { k: 'Hours of learning', v: '34.2', s: '≈ 12 minutes a day' },
    },
    activity: 'Activity · 26 weeks',
    byType: 'By exercise type',
    hardWords: 'Top hard words',
    wrongCount_one: '{{count}} mistake',
    wrongCount_other: '{{count}} mistakes',
  },
  profile: {
    title: 'Settings',
    sub: 'Profile, interface language and practice settings.',
    save: 'Save',
    saving: 'Saving…',
    saved: 'Settings saved',
    saveError: 'Could not save. Try again.',
    signOut: 'Sign out',
    rows: {
      name: { k: 'Name', h: 'Shown in your profile' },
      autoAdvance: { k: 'Auto-advance', h: 'Automatically move to the next card after a correct answer. Off by default — advance with “Continue” or Enter.' },
      reminders: {
        k: 'Email reminders',
        h: 'A short email if you haven’t practised for a while: up to 4 in the first week, then no more than once a week.',
        unverified: 'Reminders go only to a confirmed email address.',
        // The toggle saves right away (demo fixes spec 1.10).
        saved: 'Saved',
        saveError: 'Didn’t save — try again',
      },
      lang: { k: 'Interface language', h: 'Language of menus and hints' },
    },
  },
  unsubscribe: {
    kicker: 'Reminders',
    pending: 'Turning reminders off…',
    saving: 'Saving…',
    off: {
      title: 'Done',
      body: 'You won’t get reminder emails anymore. You can turn them back on here or in Settings.',
    },
    on: {
      title: 'Reminders are on',
      body: 'We’ll send a short email if you haven’t practised for a while.',
    },
    resubscribe: 'Turn reminders back on',
    unsubscribeAgain: 'Unsubscribe',
    open: 'Open Lomora',
    toggleError: 'Could not save. Try again.',
    invalid: {
      title: 'This link didn’t work',
      body: 'It may be outdated or copied incompletely. You can turn reminders off in Settings.',
      settings: 'Open Settings',
    },
    error: {
      title: 'Could not turn reminders off',
      body: 'The server didn’t respond. Try again.',
      rateLimit: 'Too many attempts. Wait a minute and try again.',
      retry: 'Try again',
    },
  },
  stub: {
    placeholder: 'Coming soon: {{title}}',
    sub: 'This section will appear in upcoming steps. For now only Auth → Onboarding → Home are available.',
  },
  user: {
    me: {
      name: 'Alex Petrov',
      email: 'alex@example.com',
    },
  },
  plans: {
    title: 'Plans',
    sub: 'Credits are spent only on cards prepared by AI. Manual cards are always free and unlimited.',
    free: 'Free',
    perMonth: '{{price}} ₽ / mo',
    perDayLabel: 'credits a day',
    current: 'Current plan',
    choose: 'Switch',
    pay: 'Get plan',
    switch: 'Switch',
    extend: 'Renew',
    payPending: 'Creating payment…',
    payNote: 'One-time payment · 30 days of access',
    onSwitch: 'one-time on switch',
    payErrorTitle: 'Couldn’t start payment',
    payErrorMessage: 'Please try again in a minute.',
    loadError: 'Couldn’t load the plans. Refresh the page.',
    usageToday: 'Used today {{used}} of {{limit}}',
    soonTitle: 'Payments soon',
    soonMessage: 'We’re connecting payments — the subscription will appear here very soon.',
    tagline: {
      DEMO: 'Start with no investment',
      PRO: 'For regular practice',
      PREMIUM: 'Maximum pace',
    },
    moreWords: '{{x}}× more new words with the full breakdown every day',
    donateTitle: 'Support the project',
    donateSub: 'A one-time donation helps grow Lomora and keep AI generation available for everyone.',
    donateCta: 'Support',
    donateCtaAmount: 'Support with {{amount}} ₽',
    donateCustom: 'Custom amount',
    donateMin: 'Minimum amount is {{min}} ₽',
  },
  billing: {
    title: 'Plans',
    // Plans page, following the “Страница тарифов” / “Тарифы мобайл” designs.
    shop: {
      close: 'Close',
      loading: 'Loading plans',
      retry: 'Try again',
      hero: {
        demo: 'Learn the words you need.',
        demoEm: 'At your own pace.',
        pro: 'You’re on Pro.',
        proEm: 'Need more credits?',
        max: 'You’re on Max.',
        maxEm: 'Maximum credits.',
      },
      status: {
        label: 'Your access',
        demoFree: 'free',
        demoTitle: 'No time limit',
        demoNote_one: '{{count}} credit every day · manual cards unlimited',
        demoNote_other: '{{count}} credits every day · manual cards unlimited',
        paidOn: 'paid on {{date}}',
        daysLeft_one: '{{count}} day left',
        daysLeft_other: '{{count}} days left',
        paidUntil: 'until {{date}} · no auto-renewal',
        quota: 'Credits left',
        quotaShort: 'Credits',
        resets: 'resets at {{time}} Moscow time',
        exhausted: 'out of credits · new ones at {{time}} Moscow time',
        exhaustedBonus: 'today’s are used up · spending non-expiring, new ones at {{time}} Moscow time',
        bonus_one: '+ {{count}} non-expiring credit',
        bonus_other: '+ {{count}} non-expiring credits',
      },
      features: {
        practice: 'Practise your cards',
        practiceText: 'Sessions with your own cards and modules.',
        create: 'Create cards and modules',
        createText: 'Manually — no limit.',
        ai: 'AI card generation',
        aiText: 'Translation, example and options in one tap. Manual and ready-made cards don’t use credits.',
        open: 'available',
        perDay: '{{count}} a day',
      },
      checkout: {
        choose: 'Choose a plan',
        upgrade: 'Upgrade to Max',
        yours: 'Your plan',
        daily_one: '{{count}} credit a day',
        daily_other: '{{count}} credits a day',
        allOfPro: 'everything in Pro',
        currentUntil: 'current · until {{date}}',
        upgradeTag: 'top-up for the remaining days',
        afterDate: 'available after {{date}}',
        period: 'Period',
        periodValue_one: '{{count}} day from payment',
        periodValue_other: '{{count}} days from payment',
        autoRenew: 'Auto-renewal',
        no: 'no',
        daysLeft: 'Days left',
        ends: 'Ends',
        endsSame: '{{date}} — unchanged',
        validUntil: 'Valid until',
        nextPeriod: 'Next period',
        afterEnd: 'after it ends',
        total: 'Total',
        topUp: 'Top-up',
        pay: 'Pay {{amount}}',
        payPlan: 'Pay for {{plan}}',
        upgradePay: 'Pay {{amount}} to upgrade',
        upgradeShort: 'Upgrade to Max',
        newPeriod: 'New period after {{date}}',
        footBuy: 'Your period starts right after payment · YooKassa, card not stored',
        footBuyShort: 'Starts right after payment · YooKassa',
        footUpgrade_one: '{{count}} credit is added right away · you can renew Pro after {{date}}',
        footUpgrade_other: '{{count}} credits are added right away · you can renew Pro after {{date}}',
        footUpgradeShort_one: '{{count}} credit is added right away',
        footUpgradeShort_other: '{{count}} credits are added right away',
        footCurrent: 'Manual cards don’t use credits — you can add them now too',
        footCurrentShort: 'You can add manual cards now too',
      },
      donate: {
        title: 'Support',
        note: 'one-time, doesn’t change your plan',
        noteShort: 'doesn’t change your plan',
        custom: 'other',
        placeholder: 'Custom amount',
        enter: 'Enter an amount',
        min: 'Minimum {{amount}}',
        cta: 'Support with {{amount}}',
      },
      details: {
        faq: 'Payment questions',
        history: 'Payment history',
      },
      faq: {
        autoRenew: {
          q: 'Will I be charged automatically?',
          a_one: 'No. A plan is a one-time payment for {{count}} day. When it ends, you can simply buy a new period.',
          a_other: 'No. A plan is a one-time payment for {{count}} days. When it ends, you can simply buy a new period.',
        },
        start: {
          q: 'When does my plan start?',
          a: 'At the moment of payment. For example, pay on {{start}} and the plan lasts until {{end}}.',
        },
        spend: {
          q: 'What are credits?',
          a: 'Every day at midnight Moscow time you get credits — how many depends on your plan. A credit is spent when AI prepares cards: one tap on “Create” is one credit, up to 10 meanings at a time. A topic collection: 10 words is one credit, 20 is two. If the cards couldn’t be prepared, the credit is refunded. Unused credits don’t carry over to the next day. Manual cards, ready-made modules and practice don’t use credits.',
        },
        reset: {
          q: 'When do new credits arrive?',
          a: 'Every day at {{time}} Moscow time.',
        },
        upgrade: {
          q: 'How do I switch from Pro to Max?',
          a: 'Any time during your current period. You only pay the price difference for the remaining days; the end date stays the same.',
        },
        early: {
          q: 'Can I renew early or switch from Max to Pro?',
          a: 'No. A new period, like switching to Pro, is available after the current one ends.',
        },
        afterDemo: {
          q: 'What happens when Demo ends?',
          a: 'Card creation and AI generation close. You can keep practising the cards you’ve already made.',
        },
        payment: {
          q: 'How does payment work?',
          a: 'Through YooKassa. Lomora never receives or stores your card details.',
        },
      },
      history: {
        date: 'Date',
        what: 'Item',
        sum: 'Amount',
        status: 'Status',
        item_one: '{{plan}} · {{count}} day',
        item_other: '{{plan}} · {{count}} days',
        upgrade: 'Upgrade: {{from}} → {{plan}}',
        until: 'until {{date}}',
        donation: 'Lomora support',
        donationNote: 'donation',
        paid: 'paid',
        free: 'free',
        receipts: 'Receipts are emailed after every payment.',
        empty: 'No payments yet',
        emptyText: 'Plan purchases and donations will appear here.',
      },
      legalPrefix: 'By continuing to payment, you accept the',
      legalLink: 'offer terms',
    },
    sub: 'Access is paid in 31-day periods from the purchase date. Credits are needed only for cards prepared by AI; manual cards are always free.',
    loadError: 'Couldn’t load the plans. Refresh the page.',
    pendingOtherTierTitle: 'Unfinished payment',
    pendingOtherTierMessage: 'You already have an unfinished {{tier}} payment. Finish it or wait for it to expire before choosing another plan.',
    mobile: {
      intro: 'Access is paid in 31-day periods from the purchase date. Credits are needed only for AI cards.',
      sectionPlans: 'Plans',
    },
    card: {
      free: 'Free',
      perPeriod: '/ period',
      perDay: 'credits',
      perDay2: 'a day',
      moreWords: '{{x}}× more new words than on Demo',
      accessDays: '{{count}} days of access',
      accessDays_one: '{{count}} day of access',
      accessDays_other: '{{count}} days of access',
      // Every button says what it pays for and for which dates (no period tabs).
      buy: 'Get {{plan}}',
      buySub: '{{count}} days of access from payment',
      buySub_one: '{{count}} day of access from payment',
      buySub_other: '{{count}} days of access from payment',
      upgradeNow: 'Switch to Max · +{{amount}} ₽',
      upgradeNowSub: 'top-up for the rest of the period · until {{date}}',
      currentUntil: 'In use · until {{date}}',
      lockedByMax: 'Unavailable while Max is active',
      alwaysIncluded: 'Always included — even on paid plans',
      feats: {
        ai: 'AI builds a card from any word',
        manual: 'Manual cards — unlimited',
        modes: 'Practice and card previews',
        exercises: 'Choose exercises for your session',
        check: 'Typos don’t count as mistakes',
        noAuto: 'One-time payment — no auto-renew',
      },
      unavailable: 'Unavailable',
      yourPlan: 'Your current plan · until {{date}}',
      upgradeBadge: 'upgrade',
      popularBadge: 'popular',
    },
    breakdown: {
      toggle: 'Why {{pay}} ₽ and not {{full}} ₽?',
      fullPrice: 'Max full price',
      credit: 'Pro remainder credit · {{count}} days',
      credit_one: 'Pro remainder credit · {{count}} day',
      credit_other: 'Pro remainder credit · {{count}} days',
      payToday: 'Due today',
      note: 'We credit the unused Pro days in the current period. The closer to the end of the period, the smaller the credit and the pricier the switch.',
    },
    trust: {
      gateway: 'Payment via a certified gateway',
      methods: 'Mir · Visa · Mastercard · SBP',
      receipt: 'No auto-charges',
    },
    history: {
      heading: 'History',
      count: '{{count}} periods',
      count_one: '{{count}} period',
      count_other: '{{count}} periods',
      empty: 'No paid periods yet.',
      paid: 'Paid · {{amount}} ₽',
    },
    legal:
      'By paying the invoice you agree to the offer terms.',
  },
  // Home daily task (2026-10-22): 5 new catalogue words → training → non-expiring credits.
  dailyTask: {
    kicker: 'Daily task',
    title_one: '{{count}} new word',
    title_other: '{{count}} new words',
    text: 'Words from Lomora’s ready-made modules you don’t have yet: meet them, then learn them in a training.',
    reward_one: '+{{count}} credit',
    reward_other: '+{{count}} credits',
    take: 'Get the words',
    taking: 'Picking words…',
    learn: 'Learn the words',
    starting: 'Starting the training…',
    learnNote: 'Lomora picks the exercises, no final match. Finish the training — and the credits are yours.',
    intro_one: 'Meet the words, then learn them in a training. Completing it gives {{count}} non-expiring credit.',
    intro_other: 'Meet the words, then learn them in a training. Completing it gives {{count}} non-expiring credits.',
    doneTitle: 'Daily task done',
    doneText: 'A new task tomorrow',
    emptyTitle: 'No new words yet',
    emptyText: 'You already learn every word from Lomora’s ready-made modules. Come back tomorrow.',
    toModule: 'Open the module',
    back: 'Home',
    startError: 'Could not get the words. Try again.',
    trainError: 'Could not start the training. Try again.',
    loadError: 'Could not load the task.',
    retry: 'Try again',
  },
  // Non-expiring credits granted by a training — toasts (2026-10-22).
  rewards: {
    streak: {
      title: 'Streak goes on — day {{streak}}',
      text_one: '+{{count}} non-expiring credit for your streak.',
      text_other: '+{{count}} non-expiring credits for your streak.',
    },
    comeback: {
      title: 'Welcome back!',
      text_one: '+{{count}} non-expiring credit to keep going.',
      text_other: '+{{count}} non-expiring credits to keep going.',
    },
    daily_task: {
      title: 'Daily task done',
      text_one: '+{{count}} non-expiring credit added.',
      text_other: '+{{count}} non-expiring credits added.',
    },
    earned_one: 'credit earned',
    earned_other: 'credits earned',
  },
  subscription: {
    title: 'Subscription',
    // The Demo plan (demo fixes spec 1.9): “Free plan” is gone — one state, one name, as on Plans.
    demo: {
      title: 'Demo',
      free_one: 'Free with no time limit: {{count}} credit a day. Pro and Max give more.',
      free_other: 'Free with no time limit: {{count}} credits a day. Pro and Max give more.',
      bonus_one: 'Plus {{count}} non-expiring credit.',
      bonus_other: 'Plus {{count}} non-expiring credits.',
    },
    choosePlan: 'Choose a plan',
    activeChip: 'Active',
    activeUntil: 'Active until {{date}} · then the free Demo',
  },
  payment: {
    pending: {
      title: 'Verifying your payment',
      sub: 'This takes a few seconds — please don’t close the page.',
    },
    success: {
      title: 'Payment complete',
      sub: 'Your {{tier}} plan is active — happy learning!',
      cta: 'To plans',
      planRow: 'Plan',
      amountRow: 'Paid',
      untilRow: 'Access until',
      note: 'No auto-renewal — access is active until this date. You can renew manually anytime.',
    },
    donation: {
      title: 'Thank you for your support!',
      sub: 'Your contribution helps grow Lomora. We truly appreciate it ♥',
      cta: 'To dashboard',
    },
    canceled: {
      title: 'Payment canceled',
      sub: 'The payment wasn’t completed. You can try again.',
      cta: 'Back to plans',
    },
    error: {
      title: 'Couldn’t verify the payment',
      sub: 'If you were charged, everything will apply within a couple of minutes.',
      cta: 'To plans',
    },
  },
  quota: {
    label: 'Left',
    outOf: 'of {{limit}}',
    planLine: '{{plan}} · {{limit}} a day',
    outNext: 'New at midnight. {{plan}}: {{limit}} a day',
    outLast: 'New at midnight',
    balanceTitle: '{{left}} of {{limit}} credits left today. New credits arrive every day at midnight Moscow time.',
    value: '{{used}} / {{limit}}',
    remaining: '{{remaining}} left',
    used: '{{used}} of {{limit}}',
    usedTitle: '{{used}} of {{limit}} credits used today, {{left}} left. New credits arrive every day at midnight Moscow time.',
    exhausted: 'Out of credits for today',
    resetAt: 'new at {{time}}',
    bonus_one: '+{{count}} non-expiring',
    bonus_other: '+{{count}} non-expiring',
    bonusTitle_one: 'Plus {{count}} non-expiring credit — spent once today’s run out.',
    bonusTitle_other: 'Plus {{count}} non-expiring credits — spent once today’s run out.',
    bonusSpending: 'today’s are used up · spending non-expiring',
    upgrade: 'Upgrade plan',
    reached:
      'You’re out of credits for today ({{used}}/{{limit}}). New ones arrive at {{time}} — meanwhile you can create cards manually.',
  },
  admin: {
    tabs: {
      label: 'Admin section',
      product: 'Analytics',
      tech: 'Tech',
    },
    product: {
      since: 'counted since {{date}}',
      notTracked: 'counting starts after release',
      tiles: {
        registered: 'New in {{days}} days',
        returned: 'Came back at least once',
        returnedSub: '{{n}} of {{base}} · without today’s sign-ups',
        median: 'First return',
        medianValue: 'after {{n}} d',
        medianSub: 'median among those who came back',
        events: 'Visits and page opens',
        eventsSub: 'logged in our journal since this day',
        eventsNone: 'the journal starts after release',
      },
      cohorts: {
        title: 'Retention by sign-up week',
        hint: 'share back within 1, 3, 7, 14 and 30 days; “—” — the week is too young',
        week: 'Week',
        size: 'New',
        day: '{{n}} d',
      },
      buckets: {
        title: 'When they come back',
        hint: 'first return of new users in {{days}} days, without today',
        d1: 'Next day',
        d2_3: 'In 2–3 days',
        d4_7: 'In 4–7 days',
        d8_14: 'In 8–14 days',
        d15_30: 'In 15–30 days',
        d31: 'After a month',
        never: 'Never came back',
      },
      funnel: {
        title: 'New users funnel',
        hint: 'share of sign-ups in {{days}} days',
        registered: 'Signed up',
        onboarding: 'Finished onboarding',
        verified: 'Confirmed email',
        card_tried: 'Tried to create a card',
        card_created: 'Created a card',
        module_created: 'Created own module',
        words_added: 'Added words to a module',
        topics_opened: 'Opened topic picks',
        topic_batch: 'Made a topic pick',
        game_opened: 'Opened the game',
        mission_finished: 'Finished a daily mission',
        daily_task_taken: 'Took the daily task',
        returned: 'Came back another day',
        second_training_day: 'Practised another day',
        plans_opened: 'Opened plans',
        payment_started: 'Started payment',
        paid: 'Paid',
      },
      features: {
        title: 'Features',
        hint: 'in {{days}} days',
        people: 'Users',
        times: 'Times',
        app_open: 'Opened the app',
        card_presses: 'Pressed “Create”',
        topics_opened: 'Opened topic picks',
        topic_batches: 'Made a topic pick',
        trainings_started: 'Started practice',
        trainings_completed: 'Finished practice',
        library_added: 'Added a ready module',
        plans_opened: 'Opened plans',
        payments_started: 'Started payment',
        paid: 'Paid',
      },
      emails: {
        title: 'Reminder emails',
        hint: 'in {{days}} days · “came back” — an action or visit within 3 days after the email',
        empty: 'No emails in this period: reminders are still off in production.',
        kind: 'Email',
        sent: 'Sent',
        clicked: 'Clicked',
        returned: 'Came back',
        trained: 'Practised',
        holdout: 'Control',
        holdoutHint: 'Deliberately not emailed: how many came back on their own · how many',
        kinds: {
          onb_d1: 'Onboarding, day 1',
          onb_d2: 'Onboarding, day 2',
          onb_d4: 'Onboarding, day 4',
          onb_d7: 'Onboarding, day 7',
          weekly: 'Weekly',
          outreach: 'Personal email',
        },
      },
      modules: {
        title: 'Modules',
        hint: 'in {{days}} days',
        count: 'Count',
        created: 'Created own module',
        added: 'Added a ready module',
        via: {
          library: 'from the library',
          onboarding: 'during onboarding, chosen topic',
          onboarding_auto: 'during onboarding, starter',
          share: 'via a link',
          other: 'before 19.10, no source',
        },
        words: 'Added words to modules',
        wordsOwn: 'to own modules',
        wordsCopies: 'to copies of ready ones',
        deleted: 'Deleted a module',
        top: 'Most added from the catalogue',
        topEmpty: 'No ready modules were added in this period.',
      },
      metrika: {
        title: 'Where they come from · Yandex Metrica',
        hint: 'in {{days}} days · {{visits}} visits, {{users}} visitors, {{registrations}} sign-ups',
        off: 'Metrica is not connected: YANDEX_METRIKA_TOKEN is missing.',
        error: 'Metrica did not respond — try later.',
        source: 'Source',
        visits: 'Visits',
        users: 'Visitors',
        registrations: 'Sign-ups',
        conversion: 'Conversion',
        noUtm: 'No visits with utm tags in this period.',
      },
      users: {
        title: 'New users',
        onlyLost: 'only those who did not come back',
        count: '{{shown}} of {{total}} in {{days}} days',
        date: 'Date',
        user: 'User',
        source: 'Source',
        onboarding: 'Onboarding',
        verified: 'Email',
        presses: '“Create”',
        modules: 'Modules',
        words: 'Words',
        batches: 'Picks',
        trainings: 'Practice',
        game: 'Game',
        stories: 'Stories',
        missions: 'Daily mission',
        boss: 'Grammosaur',
        bossHint: 'Grammosaur fights: won / started',
        dailyTask: 'Daily task',
        days: 'Days',
        last: 'Last',
        plan: 'Plan',
      },
    },
    // Backend error journal (2026-10-13): ERROR+ from the API and workers, expected 4xx refusals excluded.
    errors: {
      title: 'Backend errors',
      sub: 'ERROR-level records from the API and workers: 5xx responses, failed jobs, external service failures. Refusals to the user — a wrong password, a taken email, an expired link — are not counted.',
      today: 'Errors today',
      week: 'Last 7 days',
      month: 'Last 30 days',
      yesterday: 'yesterday — {{n}}',
      prev: 'previous {{days}} days — {{n}}',
      notTracked: 'tracking starts once the error journal is deployed',
      since: 'tracked since {{date}}',
      total: '{{total}} in {{days}} days',
      chart: 'Errors by day',
      series: 'Errors',
      places: 'Where it fails',
      placesHint: 'last {{days}} days, by count',
      placesEmpty: 'No errors in this period.',
      recent: 'Latest errors',
      recentHint: 'newest first',
      recentEmpty: 'No errors yet.',
      showAll: 'Show all · {{n}}',
      showLess: 'Collapse',
      kibana: 'Open in Kibana',
      inKibana: 'in Kibana',
      last: 'last {{time}}',
      todayLink: 'errors today: {{n}}',
      loadError: 'Could not load the error journal.',
    },
    analytics: {
      title: 'Analytics',
      sub: 'Days in Moscow time',
      periodLabel: 'Period',
      periodOption: '{{days}} d',
      period: 'last {{days}} days',
      activeHint: 'took an action: studied, created cards or collections',
      roundsHint: '{{words}} · topic collections: {{topics}}',
      spendHint: '{{total}} · {{avg}} a day on average',
      revenueHint: '{{total}} · successful payments',
      unitsNotTracked: 'tracking starts with the first generation after release',
      unitsSince: 'tracked since {{date}}',
      unitsTotal: '{{total}} in total',
      kpi: {
        users: 'Users',
        usersSub: 'today +{{today}} · last {{days}} days +{{period}}',
        activeToday: 'Active today',
        activeSub: '7 d — {{week}} · 30 d — {{month}}',
        activePeriod: 'Active, last {{days}} days',
        ofUsers: '{{pct}} of all users',
        paying: 'Paying now',
        payingSub: 'Pro {{pro}} · Max {{max}}',
        revenue: 'Revenue, last {{days}} days',
        revenueSub: 'successful payments',
        units: 'AI generations today',
        unitsSub: '{{avg}} a day on average · {{total}} in total',
        spend: 'Model spend, last {{days}} days',
        spendSub: 'today {{today}} · month forecast {{month}}',
        margin: 'Revenue minus model',
        marginSub: 'before fees, tax and servers',
      },
      chart: {
        newUsers: 'New users',
        active: 'Active users',
        units: 'AI generations from the limit',
        rounds: 'Word generations by model rounds',
        spend: 'Model spend, ₽',
        revenue: 'Revenue, ₽',
        cards: 'Cards added',
        sessions: 'Training sessions',
      },
      series: {
        verified: 'verified email',
        unverified: 'not verified',
        active: 'all active',
        learners: 'studied',
        creators: 'created',
        units: 'limit units',
        roundOne: 'first try',
        roundTwo: '2nd round',
        roundThree: '3rd round and more',
        spend: 'spend',
        spendWords: 'words and collections',
        spendGame: 'game',
        spendGrammar: 'grammar',
        revenue: 'revenue',
        cardsAi: 'with AI',
        cardsManual: 'manual',
        started: 'started',
        completed: 'completed',
      },
      heatmap: {
        title: 'Word generations by user',
        hint: 'learners: {{count}} · last {{days}} days',
        empty: 'Nobody generated words or played in this period.',
        total: 'period',
        words_one: '{{count}} word',
        words_other: '{{count}} words',
        retry: 'retries {{n}}',
        scale: 'words a day',
        rounds: '2nd round: {{two}} · 3rd and more: {{three}}',
        topics: 'topic collections: {{n}}',
        units: 'limit: {{n}}',
        game_one: 'game: {{count}} turn · {{rub}}',
        game_other: 'game: {{count}} turns · {{rub}}',
        grammar_one: 'grammar: {{count}} check · {{rub}}',
        grammar_other: 'grammar: {{count}} checks · {{rub}}',
        played: 'game turns that day',
        playedLegend: 'game or grammar (not counted as words)',
      },
      plans: {
        title: 'Plans now',
        hint: '{{total}} in total',
      },
      funnel: {
        title: 'New user funnel',
        registered: 'Signed up',
        verified: 'Verified email',
        firstCard: 'Added a card',
        firstSession: 'Started training',
        paid: 'Paid',
      },
      health: {
        title: 'Retention and quality',
        qualityTitle: 'Generation quality',
        nextDay: 'Came back the next day',
        nextDayHint: 'of sign-ups in the last 30 days',
        week: 'Active in the last week',
        weekHint: 'of users who joined 7+ days ago',
        failed: 'Failed generations',
        failedHint: 'cards, last {{days}} days',
        extra: 'Repeat model calls',
        extraHint: 'share of calls beyond the first',
        topicFailed: 'Failed collections',
        topicFailedHint: 'last {{days}} days, generations refunded',
      },
    },
    title: 'Generation spend',
    sub: 'Every user and what their card generations cost in rubles. “Today” starts at 00:00 Moscow time, the month is the last {{days}} days.',
    generatedAt: 'Updated {{time}}',
    error: 'Couldn’t load the dashboard. Refresh the page.',
    noAccess: {
      title: 'No access',
      body: 'This section is available to administrators only.',
    },
    measuredSince: 'Tokens counted since {{date}} · rate {{rate}} ₽/$',
    notMeasured: 'No tokens recorded yet — spend will appear after the first generation.',
    payments: 'Payments without an issued period: {{n}} for {{sum}}. Check the YooKassa webhooks.',
    calls: {
      jobs_one: '{{days}} days — {{count}} word generation',
      jobs_other: '{{days}} days — {{count}} word generations',
      one: '1 model call — {{pct}}',
      two: '2 calls — {{pct}}',
      threePlus: '3 or more — {{pct}}',
      extra: 'retries — {{rub}} ({{pct}} of word spend)',
      play: 'game and grammar — {{rub}} (not counted as generations)',
    },
    table: {
      user: 'User',
      plan: 'Plan',
      genToday: 'Gen. today',
      genMonth: 'Gen. {{days}}d',
      rubToday: '₽ today',
      rubAvgDay: '₽ per day',
      rubMonth: '₽ {{days}}d',
      avgHint: 'Average: {{days}}-day spend ÷ {{days}}',
      extra: 'Retries',
      extraCalls_one: '{{count}} call',
      extraCalls_other: '{{count}} calls',
      play: 'game {{rub}} of it',
      playHint: 'Game turns and grammar checks: included in rubles, not in generations',
      joined: 'Joined',
      total_one: 'Total · {{count}} user',
      total_other: 'Total · {{count}} users',
      admin: 'admin',
      emailNo: 'email not verified',
      empty: 'No users yet.',
    },
  },
  // «Survive London» (2026-10-22): stories with an AI game master, the daily mission, the mistakes boss.
  stories: {
    hub: {
      kicker: 'New · game',
      title: 'Survive London',
      sub: 'Talk to Londoners in English — by typing or by voice. The AI game master invents a new plot every time and explains every mistake.',
      mapLabel: 'Pixel map of London: Heathrow airport, Paddington station, a cafe, a hotel, the Tower with the boss and the locked office of chapter two',
      mapHint: 'Tap a building — the hero walks there. Drag the map to look around.',
      loadError: 'Could not load the game. Refresh the page.',
      stateError: 'The game didn’t load',
      stateErrorText: 'Check your connection and try again.',
      retry: 'Retry',
    },
    daily: {
      kicker: 'Daily mission',
      character: 'You talk to {{name}}, up to {{turns}} replies',
      start: 'Start the mission',
      startFree: 'Start for free',
      resume: 'Continue',
      viewResult: 'Results',
      again: 'A new mission tomorrow at 00:00 Moscow time',
      extraGoal_one: 'Bonus goal: no mistakes — +{{count}} more credit',
      extraGoal_other: 'Bonus goal: no mistakes — +{{count}} more credits',
    },
    story: {
      kicker: 'Story',
      goal: 'Goal: {{goal}}',
      play: 'Play',
      resume: 'Continue',
      replay: 'New plot',
      best: 'Best result',
      runs_one: '{{count}} playthrough',
      runs_other: '{{count}} playthroughs',
      endings: 'Endings',
      endingsCount: '{{n}} of {{total}}',
      secret: 'Secret',
      stamps: 'Passport stamps',
      toPlans: 'Plans',
    },
    boss: {
      kicker: 'Boss',
      desc: 'The Grammarsaurus keeps your mistakes in jars. Fix the sentence and the jar bursts: the mistake is gone.',
      open_one: '{{count}} of your mistakes is waiting to be fixed',
      open_other: '{{count}} of your mistakes are waiting to be fixed',
      noOwn: 'No mistakes of your own yet — the Grammarsaurus uses mistakes Russian speakers often make.',
      wins: 'Wins: {{n}}',
      resolved: 'Fixed in fights: {{n}}',
      fight: 'Fight',
      resume: 'Continue the fight',
    },
    mistakes: {
      kicker: 'My mistakes',
      title: 'My mistakes',
      count_one: '{{count}} entry',
      count_other: '{{count}} entries',
      cardText: 'Every correction from the game, missions and fights: what was wrong, how to say it and why.',
      sub: 'Every correction from the game, daily missions and Grammarsaurus fights. Tap a mistake to read why.',
      open: 'Open',
      back: 'Back to the game',
      empty: 'No mistakes yet. Talk to the locals or play the daily mission\u00a0— we’ll go through every reply.',
      filterLabel: 'Which mistakes to show',
      filters: {
        all: 'All',
        open: 'Not fixed',
        grammar: 'Grammar',
        pron: 'Pronunciation',
      },
      grammar: 'Grammar',
      pron: 'Pronunciation',
      resolved: 'Fixed in a fight',
      repeats: 'Repeated: {{n}}',
      sentence: 'Your reply',
      heard: 'We heard',
      corrected: 'Better',
      fightBoss: 'Fight the Grammarsaurus',
    },
    chapter: {
      kicker: 'Coming soon',
      locked: 'Chapter in progress',
      ask: 'Want it out sooner?',
      yes: 'Yes, I want it!',
      like: 'Like',
      thanks: 'Thanks! This tells us what to build first.',
      cta: 'I want it sooner',
      chosenYes: 'You are waiting for this chapter',
      chosenLike: 'You like the idea',
    },
    verify: {
      title: 'Confirm your email to keep playing',
      body: 'We’ll unlock the Grammarsaurus fight, energy top-ups and your own words. The link is in the email we sent when you signed up.',
      bodyTo: 'We’ll unlock the Grammarsaurus fight, energy top-ups and your own words. The link is in the email we sent to {{email}}.',
    },
    play: {
      back: 'Map',
      goal: 'Goal',
      turn: 'turn {{n}} of {{total}}',
      round: 'Round {{n}} of {{total}}',
      turnShort: 'turn {{n}}/{{total}}',
      roundShort: 'round {{n}}/{{total}}',
      replay: 'Replay',
      slow: 'Slower',
      thinking: '{{name}} is thinking',
      you: 'You',
      heard: 'Recognised',
      hints: 'Hint',
      hintsTitle: 'You could answer like this — type it in your own words or say it aloud:',
      placeholder: 'Answer in English…',
      placeholderBoss: 'Fix the sentence and send…',
      send: 'Send',
      mic: 'Answer by voice',
      micStop: 'Done',
      micCancel: 'Cancel',
      micDenied: 'No microphone access. Allow it in the browser settings or type your answer.',
      micUnsupported: 'This browser cannot record voice — type your answer.',
      recording: 'Recording',
      results: 'Results',
      event: 'Event',
      steps: 'Mission steps',
      allSteps: 'All steps done',
      bossHp: 'Grammarsaurus',
      yourHp: 'You',
      hint: 'Hint: {{rule}}',
      showHint: 'Show a hint',
      mineTag: 'your mistake',
      typicalTag: 'common mistake',
      history: 'Conversation',
      howTitle: 'How to play',
      how: 'Listen to the character and answer out loud with “Tap and speak”. See the lines as text with “Text”, write instead with “Type instead”. Voice answers are checked for grammar and pronunciation, written ones for grammar. Feedback appears here after each answer.',
      howBoss: 'The Grammarsaurus says a sentence with a mistake — it is already in the answer field. Fix it and send, or say it correctly aloud. A hit bursts a jar, a miss costs a heart.',
      arenaLabel: 'Fight with the Grammarsaurus at the Tower',
      sceneLabel: 'Pixel London: {{place}}',
      restartFailed: 'Start again',
      sendNow: 'Send now',
      speaking: '{{name}} is speaking…',
      waiting: '{{name}} is waiting for your answer',
      listen: 'Listen',
      text: 'Text',
      translate: 'Translation',
      insertHint: 'Insert',
      sceneWords: 'Words',
      talk: 'Tap and speak',
      talkShort: 'Speak',
      typeShort: 'Type',
      sending: 'Sending…',
      typeInstead: 'Type instead',
      voiceInstead: 'Answer by voice',
      hearing: 'I can hear you',
      speakNow: 'Speak…',
      micMissing: 'No microphone found. Plug one in or answer in text.',
      micBusy: 'The microphone is busy in another app. Close it and press again, or type your answer.',
      resources: {
        money: 'Money',
        time: 'Time',
        battery: 'Phone battery',
        trust: 'Trust',
        deadline: 'until {{time}}',
      },
      errors: {
        unavailable: 'The game master is not answering right now. This play does not count — try again a bit later.',
        voice: 'Could not make out your voice. Say it again a bit louder or type your answer.',
        rate: 'Too fast. Wait a couple of seconds and send again.',
        generic: 'Could not send your answer. Check the connection and try again.',
        offline: 'No connection\u00a0— your answer was not sent. It is kept in the field: we will send it once you are back online.',
        resending: 'Back online\u00a0— sending your answer…',
        offlineVoice: 'No connection\u00a0— your answer was not sent. The recording is kept: we will send it once you are back online.',
        finished: 'This game is already over.',
        notFound: 'Game not found.',
        noTokens: 'Not enough credits — new ones arrive at 00:00 Moscow time.',
        verify: 'Confirm your email first\u00a0— the link is in our email.',
        guestLimit: 'Missions without a confirmed email are over for today. Confirm your email to keep playing.',
      },
    },
    tactics: {
      polite: 'Polite',
      bargain: 'Bargain',
      direct: 'Direct',
      joke: 'Joke',
      idea: 'Idea',
    },
    feedback: {
      title: 'Reply review',
      clean: 'No mistakes',
      fixes_one: '{{count}} correction',
      fixes_other: '{{count}} corrections',
      notEnglish: 'Not in English — the character did not understand',
      notAnswered: 'The reply does not answer the question — listen again',
      corrected: 'A better way to say it',
      why: 'Why',
      lesson: 'Lesson: {{title}} →',
      yourAnswer: 'Your reply',
      pronTitle: 'Pronunciation',
      pronLine: 'We heard “{{heard}}”, it should be “{{meant}}”',
      hit: 'Hit!',
      miss: 'Miss',
      right: 'Correct',
      wholeBetter: 'The whole answer, corrected',
      effectsTitle: 'What changed',
      fallback: 'The game master gave a backup line — this turn counts without a review.',
      effects: {
        money: '{{sign}}£{{v}}',
        minutes: '+{{v}} min',
        battery: 'battery {{sign}}{{v}}%',
        trust: 'trust {{sign}}{{v}}',
      },
    },
    fixes: {
      kicker: 'Reply review',
      cheat: 'Cheat sheet',
      open: 'Cheat sheet and lessons',
    },
    level: {
      kicker: 'Survive in London',
      title: 'How is your English?',
      sub: 'The locals adapt: from zero\u00a0— short simple lines, translations and hints.',
      change: 'You can change it on the game tab.',
      current: 'Your English: {{level}}',
      edit: 'change',
      choose: 'choose',
      zero: { title: 'From zero', text: 'I know a few words — I need translations and hints.' },
      basic: { title: 'A little', text: 'I understand simple phrases and can answer briefly.' },
      confident: { title: 'Confident', text: 'I can talk — give me real, natural speech.' },
    },
    ending: {
      kicker: 'Ending',
      secret: 'Secret ending',
      newEnding: 'New ending!',
      stamps: 'Stamps',
      newStamp: 'new',
      stats: {
        turns: 'turns',
        fixes: 'corrections',
        voice: 'by voice',
      },
      words: 'Words from the game',
      mistakes: 'Mistakes review',
      allMistakes: 'All my mistakes',
      noMistakes: 'Not a single mistake — well done!',
      playAgain: 'Play again — a new plot',
      toMap: 'To the map',
    },
    dailyResult: {
      done: 'Mission complete',
      partial: 'Almost there',
      none: 'Not this time',
      next: 'The next mission is tomorrow at 00:00 Moscow time.',
      toBoss: 'Finish your mistakes in a boss fight',
    },
    bossResult: {
      win: 'The Grammarsaurus is defeated!',
      lose: 'The Grammarsaurus won',
      resolved: 'Your mistakes fixed: {{n}}',
      openLeft: 'Still to fix: {{n}}',
      rounds: 'Rounds',
      again: 'Another fight',
    },
    bridge: {
      moduleName: 'Выживи в Лондоне',
      locked: 'Saving to your dictionary needs a confirmed email',
      add_one: 'Add {{count}} word to your dictionary',
      add_other: 'Add {{count}} words to your dictionary',
      adding: 'Adding…',
      added: 'Added to the module “{{name}}”',
      queued: 'AI is making the cards — they will appear in “{{name}}” in a few seconds',
      openModule: 'Open the module',
      failed: 'Could not add the words. Try again.',
      hint: 'The words go to the module “{{name}}” — you can learn them in training.',
    },
    price_one: '{{count}} credit',
    price_other: '{{count}} credits',
    noTokens: 'Out of credits',
    reward: {
      doneTitle: 'Mission complete',
      perfectTitle: 'Three stars!',
      text_one: '+{{count}} non-expiring credit added.',
      text_other: '+{{count}} non-expiring credits added.',
      got_one: 'Earned +{{count}} credit',
      got_other: 'Earned +{{count}} credits',
      none: 'No credits this time — they come for passing the mission',
      offer_one: 'Pass it — +{{done}} credit; no mistakes — +{{extra}} more',
      offer_other: 'Pass it — +{{done}} credits; no mistakes — +{{extra}} more',
    },
    goals: {
      bonus: 'Bonus goal',
      dailyBonus_one: 'at most 1 mistake — +{{count}} more token',
      dailyBonus_other: 'at most 1 mistake — +{{count}} more tokens',
      storyBonus: 'at most 2 mistakes — +1 star',
      bossBonus: 'keep every life — 3 stars',
      demoBonus: 'at most 1 mistake — 3 stars',
      status: {
        on: 'on track',
        lost: 'missed',
        done: 'done',
      },
    },
    demo: {
      kicker: 'Mission demo',
      badge: 'Survive in London · demo',
      back: 'To the site',
      backToIntro: 'Back',
      signIn: 'Sign in',
      toGame: 'To the game',
      haveAccount: 'Already have an account?',
      goal: 'Goal',
      turns_one: '{{count}} reply',
      turns_other: '{{count}} replies',
      voiceOrText: 'by voice or text',
      noSignUp: 'no sign-up',
      host: 'The cook answers like a real person, and after every reply the AI host shows your mistakes and explains them.',
      start: 'Start the mission',
      starting: 'Setting the scene…',
      resume: 'Continue the mission',
      toResults: 'Back to the results',
      how_one: 'Answer the cook in English — by voice or text. You have {{count}} reply: complete the steps of the goal.',
      how_other: 'Answer the cook in English — by voice or text. You have {{count}} replies: complete the steps of the goal.',
      ctaTitle: 'Play every day — for free',
      ctaDaily_one: 'A new mission every day — up to {{count}} token for passing it',
      ctaDaily_other: 'A new mission every day — up to {{count}} tokens for passing it',
      ctaStory: 'Stories with different endings and a boss fight made of your own mistakes (after you confirm your email)',
      ctaWords: 'Words from the game go to flashcards (after you confirm your email), mistakes go to grammar lessons',
      signUp: 'Create a free account',
      again: 'Play again',
      learnWords_one: 'Create an account and learn {{count}} word',
      learnWords_other: 'Create an account and learn {{count}} words',
      learnWordsHint: 'The words go to the “{{name}}” module — practise right after signing up.',
      mistakesHint: 'Mistakes with a link have a grammar lesson. Lessons are free after signing up.',
      wordsSaving: 'Adding the game words to the “{{name}}” module…',
      wordsFailed: "Couldn't add the game words. You can add them by hand in Words and modules.",
      wordsRetry: "Couldn't add the game words — we'll try again when you're back on the home page.",
      toWords: 'To words and modules',
      wordsSaved: 'The game words are going to the “{{name}}” module — the cards will be ready in a few seconds.',
      wordsVerifyTitle: 'Confirm your email — and the words go to a module',
      wordsVerifyText: 'The game words are waiting: once your email is confirmed, they appear in the “{{name}}” module.',
      toHome: 'To the home page',
      restart: 'Start over',
      closedTitle: "Today's demos are over",
      closedText: 'All free demos for today are taken. Create an account — the daily mission is free every day.',
      limitTitle: "Today's demo is already played",
      limitText: 'Create an account and play every day: a new mission, stories and a boss fight.',
      loadFailed: "Couldn't load the mission. Check your connection and try again.",
      errors: {
        expired: 'This demo is over or has expired.',
        busy: 'The cook is still answering your last line.',
        unavailable: "The host isn't answering right now. The demo doesn't count — start over a bit later.",
        start: "Couldn't start the demo. Try again.",
      },
    },
    devices: {
      mic: {
        checking: 'Checking the microphone…',
        ready: 'Microphone connected',
        prompt: 'Microphone: permission needed',
        denied: 'Microphone blocked',
        missing: 'No microphone found',
        busy: 'Microphone busy in another app',
        unsupported: 'This browser can’t record voice',
      },
      micNamed: 'Microphone: {{name}}',
      speaker: {
        checking: 'Checking sound…',
        ready: 'Sound on',
        missing: 'No speakers or headphones',
        unknown: 'Sound',
      },
      speakerNamed: 'Sound: {{name}}',
      allow: 'Allow',
      retry: 'Try again',
      test: 'Test',
      tested: 'Hear the beep?',
      help: {
        inApp: 'The in-app browser doesn’t give access to the microphone. Open Lomora in a regular browser: the ⋯ menu in the corner → Open in browser.',
        androidChromeApp: 'The browser blocks the microphone. Open Chrome → ⋮ → Settings → Site settings → All sites → {{host}} → Microphone → Allow: the app takes its permissions from Chrome.',
        androidChrome: 'Chrome blocks the microphone. Open ⋮ → Settings → Site settings → All sites → {{host}} → Microphone → Allow.',
        androidSamsung: 'Samsung Internet blocks the microphone. Open ≡ → Settings → Sites and downloads → Site permissions → Microphone → {{host}} → Allow.',
        androidYandex: 'Yandex Browser blocks the microphone. Open the browser menu → Settings → site permissions → Microphone → {{host}} → Allow. Didn’t help — phone Settings → Apps → Yandex Browser → Permissions → Microphone.',
        androidFirefox: 'Firefox blocks the microphone. Tap the lock in the address bar → permissions → Microphone → allow. Or ⋮ → Settings → Site permissions.',
        android: 'The browser blocks the microphone. Open the browser menu → Settings → site permissions → Microphone → {{host}} → Allow.',
        iosApp: 'The browser blocks the microphone. Open iPhone Settings → Safari → Microphone → Allow or Ask, then close and reopen Lomora.',
        iosSafari: 'Safari blocks the microphone. Tap “aA” in the address bar → Website Settings → Microphone → Allow.',
        iosOther: 'The browser blocks the microphone. Open iPhone Settings → Privacy & Security → Microphone → turn on your browser.',
        desktopApp: 'The browser blocks the microphone. Click ⋮ in the top-right corner of the Lomora window → App info → Microphone → Allow.',
        desktopYandex: 'Yandex Browser blocks the microphone. Click the icon to the left of the address → turn on Microphone → Refresh the page.',
        desktopFirefox: 'Firefox blocks the microphone. Click the crossed-out microphone to the left of the address, remove the block and reload the page.',
        desktopSafari: 'Safari blocks the microphone. In the Safari menu → Settings for {{host}} → Microphone → Allow.',
        desktop: 'The browser blocks the microphone. Click the icon to the left of the site address → Microphone → Allow.',
      },
    },
    preparing: {
      daily: 'Preparing the mission…',
      story: 'Preparing the story…',
      boss: 'Preparing the fight…',
    },
  },
  // Admin: the «Stories» block (2026-10-22).
  adminStories: {
    title: 'Stories',
    sub: 'The «Survive London» game: do learners open it, reach an ending, replay it, and what it costs. Test accounts and admins excluded.',
    opened: 'Opened the tab',
    openedSub: 'learners in the period',
    started: 'Started a story',
    startedSub: 'plays {{runs}}, reached an ending {{finished}}',
    replay: 'Replayed',
    replaySub: '2+ plays · {{share}} of starters',
    endings: 'Endings',
    dropped: 'Where they quit',
    droppedHint: 'turn they stopped at',
    turn: 'Turn {{n}}',
    more: 'More',
    avgTurns: 'Turns to an ending',
    voiceShare: 'Voice replies',
    fallbacks: 'Backup turns',
    interest: 'Waiting for chapter 2',
    interestValue: 'yes {{yes}} · like {{like}}',
    daily: 'Daily mission',
    dailyValue: '{{users}} learners · {{runs}} · done {{done}}',
    boss: 'Boss',
    bossValue: '{{users}} learners · fights {{fights}} · wins {{wins}} · fixed {{resolved}}',
    tokens: 'Game master tokens (in / out)',
    tts: 'Characters voiced',
    ttsValue: '{{period}} in the period · {{week}} in 7 days',
    empty: 'Nobody has played yet.',
    eleven: {
      left: 'ElevenLabs credits',
      of: 'of {{limit}}',
      resets: 'reset on {{date}}',
      tier: 'plan {{tier}}',
      low: 'low — new lines use the browser voice',
      notConfigured: 'No key — lines play without voice.',
      error: 'ElevenLabs did not answer ({{error}}).',
    },
    demo: {
      title: 'Demo without sign-up',
      hint: 'up to {{perIp}} per address a day · {{turns}} replies',
      today: 'Today',
      todayValue: '{{n}} of {{limit}}',
      started: 'Started',
      finished: 'Finished',
      done: 'All steps',
      voice: 'By voice',
      avgTurns: 'Replies',
      day: 'Day',
      byDay: 'Demos by day',
      empty: 'No demos yet.',
    },
    endingNames: {
      view_room: 'Room with a view',
      mia_sofa: "Mia's sofa",
      hostel: '12-bed hostel',
      cafe_dawn: 'Cafe till dawn',
      station_night: 'A night at the station',
      upgrade: 'Suite upgrade',
    },
  },
};

export type EnMessages = typeof en;
